<template>
  <div class="app">
    <Loading :value="loading"></Loading>

    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider=">">
          <v-breadcrumbs-item icons router :to='item.path' v-for="item in racourcis" :key="item.text" :disabled="item.disabled">
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br>

    <!-- STATS -->
    <v-container fluid grid-list-md v-if="droitAcces.caisse">
      <v-layout row justify>
        <v-flex md4>
          <div id="chartAllBilan" style="width: 1300px; height: 300px"></div>
        </v-flex>
      </v-layout>
    </v-container>

     <v-layout row class="elevation-6 pt-1 mb-3">
            <v-flex sm12  class="text-xs-center">
                <h3>Critères de recherche pour les factures en attente de paiement </h3>
                <v-divider class="mb-2"></v-divider>
                <el-form :inline="true" :model="formTri" id="formTri" class="demo-form-inline">
                    <el-form-item label="Période" >
                        <el-date-picker
                                style="width: 100%"
                                v-model="formTri.periode"
                                format="dd-MM-yyyy"
                                value-format="yyyy-MM-dd"
                                type="datetimerange"
                                range-separator="à"
                                start-placeholder="Début date"
                                end-placeholder="Fin date"
                        ></el-date-picker>
                    </el-form-item>

                    <el-form-item label="Trésorerie">
                        <el-select filterable multiple clearable v-model="selectTresor" placeholder="Trésorerie">
                            <el-option
                                    v-for="item in listCaisse"
                                    :key="item.id"
                                    :label="item.libelle"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Type de facture">
                        <el-select clearable v-model="selectTypes" multiple placeholder="Type de facture">
                            <el-option
                                    v-for="item in listeTypeF"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <v-tooltip bottom>
                            <v-btn @click="rechercheFacture()" slot="activator" class="white--text" color="blue" fab small>
                                <v-icon>search</v-icon>
                            </v-btn>Effectuer une recherche
                        </v-tooltip>
                    </el-form-item>
                </el-form>
            </v-flex>

        </v-layout>


         <!-- MODAL LISTE DES FACTURE EN ATTENTE DE PAIEMENT DE CAISSE ET BANQUE -->
    <v-layout row v-if="showRecherche">
       <v-flex sm12>
                <v-card class="elevation-4" >
                    <v-toolbar class="text-xs-center"   color="cyan darken-2" dark>
                        <v-toolbar-title>LISTE DES FACTURES IMPAYEES </v-toolbar-title>
                    </v-toolbar>
                      <div class="text-xs-right">
                          <v-tooltip top>
                            <v-btn   slot="activator"  color="orange" @click.stop="imprimeRech()" dark>
                              Imprimer <v-icon >print</v-icon>
                            </v-btn>
                            Imprimer la liste des factures de la recherche
                          </v-tooltip>
                      </div>

                    <v-card-title class="text-xs-center" style="height:auto;">

                          <v-layout row>
                                  <v-flex xs12>
                                    
                                    <el-table
                                      border
                                      :header-row-style="headerRowStyle"
                                      highlight-current-row
                                      :data="listResulat"
                                      :summary-method="getSumm"
                                      show-summary
                                      style="width: 100%"
                                    >

                                      <el-table-column type="expand">
                                        <template slot-scope="props">
                                          <div v-if="props.row.fourn">
                                            <v-chip dark label color="purple" text-color="white">
                                              <v-icon left>label </v-icon>
                                              <span>FOUNISSEUR/PRESTATAIRE</span>
                                            </v-chip>
                                            <el-table
                                              border
                                              highlight-current-row
                                              :header-row-style="headerRowStyle"
                                              class="elevation-2"
                                              :data="props.row.fourn"
                                              :summary-method="getSumm"
                                              show-summary
                                              style="width: 100%"
                                            >
                                              <el-table-column
                                                align="center"
                                                prop="ref"
                                                sortable
                                                label="REFERENCE"
                                              >
                                                <template slot-scope="prop">
                                                  <span
                                                    class="subheading black--text"
                                                  >{{prop.row.ref}}</span>
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                align="center"
                                                sortable
                                                prop="projet"
                                                label="PROJET"
                                              >
                                              </el-table-column>

                                              <el-table-column
                                                align="center"
                                                sortable
                                                prop="concerne"
                                                label="FOURNISSEUR"
                                              >

                                              </el-table-column>

                                               <el-table-column
                                                align="center"
                                                sortable
                                                prop="impaye"
                                                label="MONTANT IMPAYE"
                                              >
                                                <template slot-scope="prop3">
                                                  <el-tag
                                                    class="subheading"
                                                  >{{ new Intl.NumberFormat().format(prop3.row.impaye)}} FCFA</el-tag>
                                                </template>
                                              </el-table-column>

                                            </el-table>
                                          </div>
                                          <br/>
                                          <div v-if="props.row.mission">
                                            <v-chip dark label color="purple" text-color="white">
                                              <v-icon left>label</v-icon>
                                              <span>MISSION</span>
                                            </v-chip>
                                            <el-table
                                              border
                                              highlight-current-row
                                              :header-row-style="headerRowStyle"
                                              class="elevation-2"
                                              :data="props.row.mission"
                                              :summary-method="getSumm"
                                              show-summary
                                              style="width: 100%"
                                            >
                                              <el-table-column
                                                align="center"
                                                prop="ref"
                                                sortable
                                                label="REFERENCE"
                                              >
                                                <template slot-scope="prop">
                                                  <span
                                                    class="subheading black--text"
                                                  >{{prop.row.ref}}</span>
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                align="center"
                                                sortable
                                                prop="projet"
                                                label="PROJET"
                                              >
                                              </el-table-column>

                                              <el-table-column
                                                align="center"
                                                sortable
                                                prop="concerne"
                                                label="FOURNISSEUR"
                                              >

                                              </el-table-column>

                                               <el-table-column
                                                align="center"
                                                sortable
                                                prop="impaye"
                                                label="MONTANT IMPAYE"
                                              >
                                                <template slot-scope="prop3">
                                                  <el-tag
                                                    class="subheading"
                                                  >{{ new Intl.NumberFormat().format(prop3.row.impaye)}} FCFA</el-tag>
                                                </template>
                                              </el-table-column>

                                            </el-table>
                                          </div>
                                          <br/>
                                          <div v-if="props.row.interv">
                                            <v-chip dark label color="purple" text-color="white">
                                              <v-icon left>label</v-icon>
                                              <span>INTERVENTION</span>
                                            </v-chip>
                                            <el-table
                                              border
                                              highlight-current-row
                                              :header-row-style="headerRowStyle"
                                              class="elevation-2"
                                              :data="props.row.interv"
                                              :summary-method="getSumm"
                                              show-summary
                                              style="width: 100%"
                                            >
                                              <el-table-column
                                                align="center"
                                                prop="ref"
                                                sortable
                                                label="REFERENCE"
                                              >
                                                <template slot-scope="prop">
                                                  <span
                                                    class="subheading black--text"
                                                  >{{prop.row.ref}}</span>
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                align="center"
                                                sortable
                                                prop="projet"
                                                label="PROJET"
                                              >
                                              </el-table-column>

                                              <el-table-column
                                                align="center"
                                                sortable
                                                prop="concerne"
                                                label="FOURNISSEUR"
                                              >

                                              </el-table-column>

                                               <el-table-column
                                                align="center"
                                                sortable
                                                prop="impaye"
                                                label="MONTANT IMPAYE"
                                              >
                                                <template slot-scope="prop3">
                                                  <el-tag
                                                    class="subheading"
                                                  >{{ new Intl.NumberFormat().format(prop3.row.impaye)}} FCFA</el-tag>
                                                </template>
                                              </el-table-column>

                                            </el-table>
                                          </div>
                                           <br/>
                                          <div v-if="props.row.dmdfond">
                                            <v-chip dark label color="purple" text-color="white">
                                              <v-icon left>label</v-icon>
                                              <span>DEMANDE DE FOND</span>
                                            </v-chip>
                                            <el-table
                                              border
                                              highlight-current-row
                                              :header-row-style="headerRowStyle"
                                              class="elevation-2"
                                              :data="props.row.dmdfond"
                                              :summary-method="getSumm"
                                              show-summary
                                              style="width: 100%"
                                            >
                                              <el-table-column
                                                align="center"
                                                prop="ref"
                                                sortable
                                                label="REFERENCE"
                                              >
                                                <template slot-scope="prop">
                                                  <span
                                                    class="subheading black--text"
                                                  >{{prop.row.ref}}</span>
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                align="center"
                                                sortable
                                                prop="projet"
                                                label="PROJET"
                                              >
                                              </el-table-column>

                                              <el-table-column
                                                align="center"
                                                sortable
                                                prop="concerne"
                                                label="FOURNISSEUR"
                                              >

                                              </el-table-column>

                                               <el-table-column
                                                align="center"
                                                sortable
                                                prop="impaye"
                                                label="MONTANT IMPAYE"
                                              >
                                                <template slot-scope="prop3">
                                                  <el-tag
                                                    class="subheading"
                                                  >{{ new Intl.NumberFormat().format(prop3.row.impaye)}} FCFA</el-tag>
                                                </template>
                                              </el-table-column>

                                            </el-table>
                                          </div>
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        align="center"
                                        sortable
                                        prop="libelle"
                                        label="TRESORERIE"
                                      >
                                        <template slot-scope="prop">
                                          <span class="subheading black--text">{{prop.row.libelle}}</span>
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        align="center"
                                        sortable
                                        prop="totalFacture"
                                        label="MONTANT TOTAL"
                                      >
                                        <template slot-scope="prop">
                                          <el-tag
                                            class="subheading"
                                            type="warning"
                                          >
                                          {{ new Intl.NumberFormat().format(prop.row.totalFacture)}} FCFA
                                          </el-tag>
                                        </template>
                                      </el-table-column>
                                    </el-table>
                                  </v-flex>
                                </v-layout>
                    </v-card-title>
                </v-card>
            </v-flex>
    </v-layout>


    <!-- BTN AJOUT -->
    <v-spacer></v-spacer>
    <div class="text-xs-right mt-4">
      <v-tooltip top v-if="droitAcces.caisse">
        <v-btn   slot="activator"  color="orange" @click.stop="imprimeAllTresorerie()" dark>
          Imprimer <v-icon >print</v-icon>
        </v-btn>
        Imprimer la liste de la tresorerie
      </v-tooltip>

      <v-tooltip top v-if="droitAcces.create_caisse" class="ml-3">
        <v-btn  slot="activator" icons color="primary" @click.stop="newCaisse()" dark>Ajouter <v-icon right>add</v-icon></v-btn>
        Ajouter une nouvelle caisse
      </v-tooltip>
    </div>


    <!-- MODAL AJOUT DE CAISSE -->
    <v-dialog v-model="dialogAjout" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajouter une nouvelle trésorerie</span>
            <span v-if="dialogEdit">Modification de la trésorerie {{caisseCourant.ref}} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjout = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form v-model="valid" ref="formCaisse" lazy-validation id="formCaisse">
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip v-if="dialogEdit != true" text-color="white" label color="primary" style="font-size:22px; width:100%">
                  Ajout d'une nouvelle trésorerie <v-icon right>account_balance</v-icon>
                </v-chip>
                <v-chip v-if="dialogEdit" text-color="white" label color="primary" style="font-size:22px; width:100%">
                  Modifier la trésorerie {{caisseCourant.ref}} / {{caisseCourant.libelle}}<v-icon right>account_balance</v-icon>
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Type de trésorerie *</span>
                    <el-select :disabled="dialogEdit" @change="changeTresor" v-model="selectTresorerie" placeholder="Type de trésorerie" style="width:100%">
                      <el-option v-for="item in typeTresorerie" :key="item.value" :label="item.text" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Libellé de la trésorerie *</span>
                    <el-input name="libelle" placeholder="Libellé de la trésorerie" v-model="libelle" style="width:100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md12>
                  <div class="block">
                    <span class="demonstration">Gérant *</span>
                    <el-select filterable v-model="selectAdmin" placeholder="Gérant" style="width:100%">
                      <el-option v-for="item in users" :key="item.id" :label="item.nom" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md4>
                  <div v-show="selectTresorerie == 'Caisse'" class="block">
                    <span class="demonstration">Categorie de la caisse</span>
                    <el-select :disabled="dialogEdit"  v-model="categorie" placeholder="Categorie de la caisse" style="width:100%">
                      <el-option v-for="item in categorieCaisse" :key="item.value" :label="item.text" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>

                <v-flex md4>
                  <div v-show="selectTresorerie == 'Caisse'" class="block">
                    <span class="demonstration">Seuil minimum</span>
                    <el-input type="number" :min="5" name="seuilMin" placeholder="Seuil minimum" v-model="seuilMin" style="width:100%"></el-input>
                  </div>
                </v-flex>

                <v-flex md4>
                  <div v-show="selectTresorerie == 'Caisse'" class="block">
                    <span class="demonstration">Seuil maximum</span>
                    <el-input type="number" :min="5" name="seuilMax" placeholder="Seuil maximum" v-model="seuilMax" style="width:100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md12>
                  <div v-show="selectTresorerie == 'Banque'"  class="block">
                    <span class="demonstration">Numero du compte</span>
                    <el-input type="text" name="numCompte" placeholder="Numero du compte" v-model="numCompte" style="width:100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout v-show="dialogEdit == false" row>
                <v-flex md12>
                  <div class="block">
                    <span class="demonstration">Solde initial</span>
                    <el-input type="number" :min="0" name="soldeInitial" placeholder="Solde initial" v-model="soldeInitial" style="width:100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md12>
                  <v-checkbox label="Rendre la trésorerie disponible" v-model="activer" name="activer" value color="green" hide-details></v-checkbox>
                </v-flex>
              </v-layout>
              <br>

              <v-btn @click="dialogAjout = false" color="orange" dark>Annuler <v-icon right>close</v-icon></v-btn>
              <v-btn icons color="blue" @click="submitCaisse()" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

<!-- MODAL TRANSFERT CAISSE -->
    <v-dialog v-model="dialogAjoutTrans" max-width="45%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Transferer des fonds dans une autre trésorerie</span>
            <span v-if="dialogEdit">Modification du transfert de fond {{approCourant.ref}} de la caisse {{detailCaisse.ref}} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutTrans = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-form :model="transFertForm" :rules="rulesTransfer" ref="transFertForm" id="transFertForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="Le montant" prop="montantTransf">
              <el-input type="number" name="montantTransf" v-model="transFertForm.montantTransf"></el-input>
            </el-form-item>
            <el-form-item :rules="rulesAppro" label="Caisse concerne" prop="caisse">
                <el-select filterable style="width: 100%"   v-model="transFertForm.caisseSelect" placeholder="Selectionner une caisse">
                    <el-option
                    v-for="item in listCaisseTransfert"
                    :key="item.id"
                    :label="item.libelle"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Le motif" prop="libelleTransfert">
              <el-input
                      type="textarea"
                      name="libelleTransfert"
                      :rows="5"
                      placeholder="Presenter le motif"
                      v-model="transFertForm.libelleTransfert">
              </el-input>
            </el-form-item>

            <el-form-item class="text-xs-right">
              <v-btn color="grey"  @click="ClearTransfertForm" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
              <v-btn icons dark color="green" @click="validTransfert = true">Enregistrer<v-icon right>add</v-icon></v-btn>
            </el-form-item>
          </el-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


    <!-- MODAL AJOUT APPRO DE CAISSE -->
    <v-dialog v-model="dialogAjoutAppro" max-width="55%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajouter un nouvel approvisionnement à {{detailCaisse.ref}}</span>
            <span v-if="dialogEdit">Modification l'approvisionnement {{approCourant.ref}} de la caisse {{detailCaisse.ref}} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutAppro = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-form :model="approForm" :rules="rulesAppro" ref="approForm" id="approForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="Le montant" prop="montant">
              <el-input type="number" name="montantAppro" v-model="approForm.montant"></el-input>
            </el-form-item>

            <el-form-item label="Le motif" prop="motif">
              <!-- <el-input type="text" name="libelleAppro" v-model="approForm.motif"></el-input> -->
              <el-input
                      type="textarea"
                      name="libelleAppro"
                      :rows="5"
                      placeholder="Presenter le motif"
                      v-model="approForm.motif">
              </el-input>
            </el-form-item>

            <el-form-item class="text-xs-right">
              <v-btn color="grey"  @click="ClearApproForm" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
              <v-btn icons dark color="green" @click="submitApproCaisse('approForm')">Enregistrer<v-icon right>add</v-icon></v-btn>
            </el-form-item>
          </el-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT VALIDE APPRO -->
    <v-dialog v-model="dialogAjoutValideAppro" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="green">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Valider l'approvisionnement {{approCourant.ref}}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutValideAppro = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form v-model="valid" ref="formValideAppro" lazy-validation id="formValideAppro">
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip text-color="white" label color="green" style="font-size:22px; width:100%">
                  Validation approvisionnement <v-icon right>get_app</v-icon>
                </v-chip>
              </p>

              <v-layout row style="font-size:15px; font-weight:bold">
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Motif de la demande</span>
                    <el-input :value="approCourant.motif" placeholder="Motif de la demande" v-model="approCourant.motif" style="width:100%" :disabled="true"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Initiateur de la demande</span>
                    <el-input :value="approCourant.initiateur" placeholder="Initiateur de la demande" v-model="approCourant.initiateur" style="width:100%" :disabled="true"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Chargé de validation</span>
                    <el-input :value="approCourant.validateur" placeholder="Chargé de validation" v-model="approCourant.validateur" style="width:100%" :disabled="true"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Montant demandé (FCFA)</span>
                    <el-input :value="approCourant.montant" placeholder="Montant demandé (FCFA)" v-model="approCourant.montant" style="width:100%" :disabled="true"></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Réponse *</span>
                    <el-select filterable v-model="selectReponseAppro" placeholder="Réponse" style="width:100%">
                      <el-option v-for="item in reponseAppro" :key="item.value" :label="item.text" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Remarque</span>
                    <el-input type="textarea" name="remarqueAppro" placeholder="Remarque" v-model="remarqueAppro" style="width:100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>
              <br>

              <v-btn @click="dialogAjoutValideAppro = false" color="orange" dark>Annuler <v-icon right>close</v-icon></v-btn>
              <v-btn icons color="blue" v-if="droitAcces.new_valider_appro" @click="submitValideAppro()" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW CAISSE -->
    <v-dialog v-model="dialogShow" fullscreen :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Détails de la trésorerie {{ caisseCourant.libelle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShow = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row>
              <v-flex md3>
                <el-row :gutter="20">
                  <div class="grid-content" style="padding:3px; margin:5px">
                    <el-row>
                      <el-card class="box-card">
                        <div class="grid-content bg-purple">
                          <div class="text item">
                            <v-layout row>
                              <v-flex md12>
                                <p><b>Désignation : </b> {{detailCaisse.libelle}} </p>
                                <p><b>Gérant : </b> {{detailCaisseS.gerant}} </p>
                                <p><b>Catégorie : </b> {{detailCaisseS.categorie}} </p>
                                <p><b>Type de trésorerie : </b>
                                  <v-chip text-color="white" label color="orange">
                                    {{detailCaisseS.type}}
                                  </v-chip>
                                </p>
                                <p><b>Etat : </b>
                                  <v-chip v-if="detailCaisseS.etat != true" text-color="white" label color="red">
                                    FERME
                                  </v-chip>
                                  <v-chip v-if="detailCaisseS.etat == true" text-color="white" label color="green">
                                    OUVERT
                                  </v-chip>
                                </p>
                                <p><b>Solde initial : </b>
                                  <v-chip text-color="white" label color="primary">
                                    {{detailCaisseS.soldeInitial}} FCFA
                                  </v-chip>
                                </p>
                                <p><b>Solde : </b>
                                  <v-chip text-color="white" label color="primary">
                                    {{detailCaisseS.solde}} FCFA
                                  </v-chip>
                                </p>
                                <p><b>Seuil maximum : </b> {{detailCaisseS.seuilMax}} FCFA</p>
                                <p><b>Seuil minimum : </b> {{detailCaisseS.seuilMin1}} FCFA</p>
                                <p><b>Date d'enrégistrement : </b> {{detailCaisseS.created}} </p>
                                <p><b>Date de modification : </b> {{detailCaisseS.modified}} </p>
                              </v-flex>
                            </v-layout>
                          </div>
                        </div>
                      </el-card>
                    </el-row>
                  </div>
                  <br/>
                </el-row>
              </v-flex>

              <v-flex md9>
                <!-- STATS -->
                <v-container fluid grid-list-md>
                  <v-layout row justify>
                    <v-flex md4>
                      <div id="chartAllBilanCaisseOnly" style="width:950px; height:300px"></div>
                    </v-flex>
                  </v-layout>
                </v-container>

                <!-- RESUME DES SOLDES -->
                <el-row :gutter="20">
                  <div class="grid-content" style="padding:3px; margin:5px">
                    <el-row>
                      <v-container fluid grid-list-md>
                        <v-layout row>
                          <v-flex md4>
                            <el-card class="box-card">
                              <v-chip text-color="white" label color="primary" style="font-size:19px; width:100%">
                                SOLDE
                              </v-chip>
                              <v-chip text-color="white" label color="primary" style="font-size:19px; width:100%">
                                {{detailCaisseS.solde}} FCFA
                              </v-chip>
                            </el-card>
                          </v-flex>
                          <v-flex md4>
                            <el-card class="box-card">
                              <v-chip text-color="white" label color="green" style="font-size:19px; width:100%">
                                CREDIT
                              </v-chip>
                              <v-chip text-color="white" label color="green" style="font-size:19px; width:100%">
                                {{montantEntree}} FCFA
                              </v-chip>
                            </el-card>
                          </v-flex>
                          <v-flex md4>
                            <el-card class="box-card">
                              <v-chip text-color="white" label color="red" style="font-size:19px; width:100%">
                                DEBIT
                              </v-chip>
                              <v-chip text-color="white" label color="red" style="font-size:19px; width:100%">
                                {{montantSortie}} FCFA
                              </v-chip>
                            </el-card>
                          </v-flex>
                        </v-layout>


                        <!-- <v-layout row>
                          <v-flex md4>
                            <el-card class="box-card">
                              <v-chip text-color="white" label color="green" style="font-size:19px; width:100%">
                                TVA ENCAISSEE
                              </v-chip>
                              <v-chip text-color="white" label color="green" style="font-size:19px; width:100%">
                                {{montantTvaEntree}} FCFA
                              </v-chip>
                            </el-card>
                          </v-flex>

                          <v-flex md4>
                            <el-card class="box-card">
                              <v-chip text-color="white" label color="green" style="font-size:19px; width:100%">
                                TVA EMISE
                              </v-chip>
                              <v-chip text-color="white" label color="green" style="font-size:19px; width:100%">
                                {{montantTvaSortie}} FCFA
                              </v-chip>
                            </el-card>
                          </v-flex>
                        </v-layout> -->

                        <v-layout row>
                          <v-flex md12>
                            <v-chip v-if="detailCaisse.solde1 <= detailCaisse.seuilMin" text-color="white" label color="orange" style="font-size:15px; width:100%">
                              ATTENTION VOTRE SEUIL MINIMUM EST ATTEINT, VEUILLEZ DONC FAIRE UN DEMANDE D'APPROVISIONNEMENT DE VOTRE CAISSE.
                            </v-chip>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </el-row>
                  </div>
                </el-row>

                <!-- <v-flex xs12 class="text-xs-right">
                  <v-tooltip top>
                        <v-btn
                            v-if="true"
                            slot="activator"
                            color="orange"
                            @click.stop="loadBilanFacture()"
                            dark
                        >
                            Imprimer facture
                            <v-icon right>print</v-icon>
                        </v-btn>Imprimer le bilan
                  </v-tooltip>
              </v-flex> -->

                <!-- RECHERCHER DES FACTURES -->
                <el-row v-if="droitAcces.caisse_facture" :gutter="20">
                  <div class="grid-content" style="padding:3px; margin:5px">
                    <el-row>
                      <v-container fluid grid-list-md>
                        <el-card class="box-card">
                          <v-form v-model="valid" ref="formFacture" lazy-validation id="formFacture">
                            <v-layout row>
                              <v-flex xs12>
                                <el-radio v-model="typeRech" label="fournisseur">fournisseur/prestataire</el-radio>
                                <el-radio v-model="typeRech" label="mission">Mission</el-radio>
                                <el-radio v-model="typeRech" label="fond">Décaissement</el-radio>
                              </v-flex>
                              <v-flex xs12>
                                <el-radio v-model="typeRech" label="intervention">Intervention</el-radio>
                                <el-radio v-model="typeRech" label="location">Location</el-radio>
                                <!-- <el-radio v-model="typeRech" label="projet">Projet</el-radio> -->
                                <el-radio v-model="typeRech" label="client">Client</el-radio>
                              </v-flex>
                            </v-layout>
                            <v-layout row>
                              <v-flex md2 v-if="typeRech !='location'">
                                <el-select clearable v-model="selectTypeFacture" placeholder="Type" style="width:100%">
                                  <el-option v-for="item in typeFacture" :key="item.value" :label="item.text" :value="item.value">
                                  </el-option>
                                </el-select>
                              </v-flex>
                              <v-flex md3 v-if="this.selectTypeFacture === 1 || this.selectTypeFacture === 2">
                                <el-date-picker value-format="yyyy-MM-dd"   id="dateFact" name="dateFact" v-model="dateFacture" :rules="dateFactureRules" type="daterange" range-separator="à" start-placeholder="Date de début" end-placeholder="Date de fin" style="width:100%" required></el-date-picker>
                              </v-flex>
                              <v-flex md2 v-if="typeRech !='location'">
                                <el-select clearable v-model="selectEtatFacture" placeholder="Etat" style="width:100%">
                                  <el-option v-for="item in etatFacture" :key="item.value" :label="item.text" :value="item.value">
                                  </el-option>
                                </el-select>
                              </v-flex>
                              <v-flex md4 v-if="typeRech== 'fournisseur'">
                                <el-select  clearable v-model="selectFournisseur" filterable placeholder="Fournisseur" style="width:100%">
                                  <el-option v-for="item in listFournisseur" :key="item.id" :label="item.libelle" :value="item.id">
                                  </el-option>
                                </el-select>
                              </v-flex>

                              <v-flex md4 v-if="typeRech== 'projet'">
                                <el-select  clearable v-model="selectProjet" filterable placeholder="Projet" style="width:100%">
                                  <el-option v-for="item in listProjet" :key="item.id" :label="item.libelle" :value="item.id">
                                  </el-option>
                                </el-select>
                              </v-flex>

                              <v-flex md4 v-if="typeRech== 'client'">
                                <el-select  clearable v-model="selectClient" filterable placeholder="Client" style="width:100%">
                                  <el-option v-for="item in listClient" :key="item.id" :label="item.libelle" :value="item.id">
                                  </el-option>
                                </el-select>
                              </v-flex>

                              <v-flex md4   v-show="typeRech== 'fond'">
                                <el-select  clearable v-model="selectDemandeur" filterable placeholder="Demandeur" style="width:100%">
                                  <el-option v-for="item in listeDemandeur" :key="item.id" :label="item.value" :value="item.id">
                                  </el-option>
                                </el-select>
                              </v-flex>
                              <v-flex md1>
                                <v-btn icons color="blue" @click="loadFacture(caisseCourant)" fab dark small> <v-icon>search</v-icon></v-btn>
                              </v-flex>
                              <!-- <v-flex md1 v-if="typeRech== 'client'">
                               <v-btn icons color="blue" @click="loadFactureClient(caisseCourant)" fab dark small> <v-icon>search</v-icon></v-btn>
                             </v-flex> -->
                            </v-layout>

                          </v-form>
                        </el-card>
                      </v-container>
                    </el-row>
                  </div>
                  <br/>
                </el-row>

                <!-- RESULTATS DES RECHERCHES -->
                <el-row v-if="listFacture.length !== 0" :gutter="20">
                  <div class="grid-content" style="padding:3px; margin:5px">
                    <el-row>
                      <v-container fluid grid-list-md>
                        <el-card class="box-card">

                          <!-- BTN IMPRESSION SEARCH -->
                          <v-layout row>
                            <v-spacer></v-spacer>
                            <v-flex xs2 class="text-xs-right">
                              <v-tooltip top v-if="droitAcces.impression_search_facture">
                                <v-btn   slot="activator" color="orange" @click.stop="imprimeSearchFacture(caisseCourant.id)" dark>
                                  Imprimer <v-icon >print</v-icon>
                                </v-btn>
                                Imprimer la liste de recherche
                              </v-tooltip>
                            </v-flex>
                          </v-layout>

                          <data-tables ref="multipleTable" :data="listFacture" v-if="droitAcces.caisse_facture" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width: 100%">
                            <p align="center">
                              <v-chip icons text-color="white" label color="primary" style="font-size:19px; width:100%">
                                LISTE DES FACTURES <v-icon right>get_app</v-icon>
                              </v-chip>
                            </p>
                            <el-table-column prop="libelle" label="Libellé" width="280" fixed>
                              <template slot-scope="scope">
                                <v-chip text-color="white" label color="primary">
                                  {{scope.row.libelle}}
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column v-if="listFacture.concerne != 'Aucun'" prop="concerne" label="Concerné" width="220"></el-table-column>
                            <el-table-column prop="etat" label="Etat" width="220">
                              <template slot-scope="scope">
                                <v-chip v-if=" isNaN(scope.row.etat) && scope.row.etat === 'IMPAYE'  " text-color="white" label color="red">
                                  {{scope.row.etat}}
                                </v-chip>
                                <v-chip v-if=" isNaN(scope.row.etat) &&  scope.row.etat === 'SOLDE' " text-color="white" label color="green">
                                  {{scope.row.etat}}
                                </v-chip>
                                <v-chip v-if=" isNaN(scope.row.etat) &&  scope.row.etat === 'EN COURS DE PAIEMENT'" text-color="white" label color="orange">
                                  {{scope.row.etat}}
                                </v-chip><v-chip v-if=" isNaN(scope.row.etat) &&  scope.row.etat === 'EN ATTENTE DE PAIEMENT'" text-color="white" label color="primary">
                                {{scope.row.etat}}
                              </v-chip>

                                <v-chip v-if="  scope.row.etatLibelle === 'IMPAYE' " text-color="white" label color="red">
                                  {{scope.row.etatLibelle}}
                                </v-chip>
                                <v-chip v-if="scope.row.etatLibelle === 'SOLDE' || scope.row.etatLibelle === 'PAYE' " text-color="white" label color="green">
                                  {{scope.row.etatLibelle}}
                                </v-chip>
                                <v-chip v-if="  scope.row.etatLibelle === 'EN COURS DE PAIEMENT'" text-color="white" label color="orange">
                                  {{scope.row.etatLibelle}}
                                </v-chip><v-chip v-if="  scope.row.etatLibelle === 'EN ATTENTE DE PAIEMENT'" text-color="white" label color="primary">
                                {{scope.row.etatLibelle}}
                              </v-chip>
                              </template>

                            </el-table-column>
                            <el-table-column prop="total" label="Montant" width="220">
                              <template slot-scope="scope">
                                <v-chip text-color="white" label color="secondary">
                                  {{scope.row.total}} FCFA
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column prop="impaye" label="Reste à payer" width="220">
                              <template slot-scope="scope">
                                <v-chip text-color="white" label color="warning">
                                  {{scope.row.impaye}} FCFA
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column label="Actions" width="140" fixed="right">
                              <template slot-scope="scope">
                                <v-btn icons color="green" @click="loadRegement(scope.row, scope.row.type)" fab dark small> <v-icon>local_atm</v-icon>
                                </v-btn>
                                <v-btn v-if="scope.row.type != 3 && scope.row.type != 5" icons color="orange" @click="imprimerFacture(scope.row)" fab dark small> <v-icon>print</v-icon>
                                </v-btn>
                                <!-- <v-btn icons color="blue" @click="submitReglement()" :disabled="!valid" dark>Retour<v-icon right>add</v-icon></v-btn> -->
                              </template>
                            </el-table-column>
                          </data-tables>
                        </el-card>
                      </v-container>
                    </el-row>
                  </div>
                  <br/>
                </el-row>

                <!-- LISTE DES APPRO CAISSE -->

                <el-row :gutter="20" v-if="listApproCaisse.length !=0 && droitAcces.caisse_appro">
                  <div class="grid-content" style="padding:3px; margin:5px">
                    <p align="center">
                      <v-chip icons text-color="white" label color="primary" style="font-size:19px; width:100%">
                        HISTORIQUE DES APPROVISIONNEMENTS <v-icon right>get_app</v-icon>
                      </v-chip>
                    </p>
                    <el-row>
                      <v-container fluid grid-list-md>
                        <el-card class="box-card">

                          <!-- BTN IMPRESSION HISTO -->
                          <v-layout row>
                            <v-flex xs12>
                              <v-chip text-color="white" label color="green" style="font-size:12px; width:100%">
                                MONTANT TOTAL DES APPROVISIONNEMENTS: {{montantEntree}} FCFA
                              </v-chip>
                            </v-flex>

                            <v-flex xs2 class="text-xs-right">
                              <v-tooltip top>
                                <v-btn   slot="activator" color="orange" @click.stop="imprimeHistoCaisse(caisseCourant.id)" dark>
                                  Imprimer <v-icon >print</v-icon>
                                </v-btn>
                                Imprimer l'historique des approvisionnements
                              </v-tooltip>
                            </v-flex>

                          </v-layout>

                          <data-tables ref="multipleTable" :data="listApproCaisse" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width: 100%">
                            <el-table-column prop="motif" label="Libellé" width="280" fixed>
                              <template slot-scope="scope">
                                <v-chip text-color="white" label color="primary">
                                  {{scope.row.motif}}
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column prop="etat" label="Etat" width="220">
                              <template slot-scope="scope">
                                <v-chip v-if="scope.row.valide === 0" outline text-color="green" label color="green">
                                  EN ATTENTE DE VALIDATION
                                </v-chip>
                                <v-chip v-else-if="scope.row.valide === 1 && scope.row.modeAppro != 4" outline text-color="primary" label color="primary">
                                  VALIDER PAR LE DG
                                </v-chip>
                                 <v-chip v-else-if="scope.row.modeAppro == 4" outline text-color="grey" label color="grey">
                                  TRANSFERT DE FOND
                                </v-chip>
                                <v-chip v-else-if="scope.row.valide === 2" text-color="white" label color="red">
                                  REFUSER PAR LE DG
                                </v-chip>
                                <v-chip v-if="scope.row.status === 0" text-color="white" label color="primary">
                                  EN COURS DE TRAITEMENT
                                </v-chip>
                                <v-chip v-else-if="scope.row.status === 1" text-color="white" label color="red">
                                  TRAITEMENT TERMINE
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column prop="validateur" label="En charge de valider" width="220"></el-table-column>
                            <el-table-column prop="montant" label="Montant" width="220">
                              <template slot-scope="scope">
                                <v-chip text-color="white" label color="secondary">
                                  {{scope.row.montant}} FCFA
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column label="Actions" width="140" fixed="right">
                              <template slot-scope="scope">
                                <v-btn
                                class="tooltip-btn"
                                title="Détails"
                                icons color="green"  
                                @click="showAppro(scope.row)" 
                                fab dark small
                                > <v-icon>folder_open</v-icon>
                                </v-btn>
                                <!-- <v-btn v-if="scope.row.valide === 0" icons color="green" @click="newValideAppro(scope.row)" fab dark small> <v-icon>done_all</v-icon>
                                </v-btn> -->
                                <v-btn v-if="scope.row.valide === 0 && scope.row.etat === false && droitAcces.edit_appro_caisse"
                                class="tooltip-btn"
                                title="Modifier"
                                icons color="primary" @click="editAppro(scope.row)" fab dark small> <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn icons
                                class="tooltip-btn"
                                title="Imprimer"
                                 color="orange"  @click="imprimerAppro(scope.row)" fab dark small> <v-icon>print</v-icon>
                                </v-btn>
                                <v-tooltip top>
                                  <v-btn
                                  class="tooltip-btn"
                                  title="Supprimer"
                                   v-if="scope.row.valide === 0"  slot="activator" @click.stop="dialogSuprAppro = true; idAppro = scope.row.id;" fab dark small color="red">
                                    <v-icon dark>delete</v-icon>
                                  </v-btn>
                                  Supprimer
                                </v-tooltip>
                              </template>
                            </el-table-column>
                          </data-tables>
                        </el-card>
                      </v-container>
                    </el-row>
                  </div>
                  <br/>
                </el-row>

                <!-- HISTORIQUE DES OPERATIONS -->
                <el-row :gutter="20">
                  <div class="grid-content" style="padding:3px; margin:5px">
                    <p align="center">
                      <v-chip icons text-color="white" label color="primary" style="font-size:19px; width:100%">
                        HISTORIQUE DES 30 DERNIERES OPERATIONS <v-icon right>get_app</v-icon>
                      </v-chip>
                    </p>
                    <el-row>
                      <v-container fluid grid-list-md>
                        <el-card class="box-card">
                          <!-- RECHERCHER DES FACTURES -->
                          <el-row :gutter="20">
                            <div class="grid-content" style="padding:3px; margin:5px">
                              <el-row>
                                <v-container fluid grid-list-md>
                                  <el-card class="box-card">
                                    <v-form ref="formOperation" lazy-validation id="formOperation">
                                      <v-layout row>
                                        <v-flex md6>
                                          <el-date-picker name="dateOperation" v-model="dateOperation" :rules="dateOperationRules" type="daterange" range-separator="-" start-placeholder="Date de début" end-placeholder="Date de fin" style="width:100%" required></el-date-picker>
                                        </v-flex>
                                        <v-flex md3>
                                          <el-dropdown size="small" split-button type="primary" @command="handleCommand" @click="handleClick" >
                                            recherche
                                            <el-dropdown-menu slot="dropdown" >
                                              <el-dropdown-item command="all">Afficher toutes les transactions</el-dropdown-item>
                                            </el-dropdown-menu>
                                          </el-dropdown>
                                        </v-flex>
                                      </v-layout>
                                    </v-form>
                                  </el-card>
                                </v-container>
                              </el-row>
                            </div>
                            <br/>
                          </el-row>

                          <!-- BTN IMPRESSION -->
                          <v-layout row>
                            <v-flex xs3 >
                              <el-col :span="2"  v-if="droitAcces.imprime_pdf_historique_caisse">
                                <el-popover
                                        ref="popover5"
                                        placement="top"
                                        width="180"
                                        trigger="hover">
                                  <p>Veuillez choisir le format d'impression ?</p>
                                  <div style="text-align: right; margin: 0">
                                    <el-button type="success" size="mini" @click="imprimeListeHis('PDF')">PDF</el-button>
                                    <el-button type="primary" size="mini" @click="imprimeListeHis('EXC')">EXCEL</el-button>
                                  </div>
                                </el-popover>
                                <div>
                                  <el-button v-popover:popover5 type="warning" :disabled="disabledBtn"
                                             icon="el-icon-printer" >Imprimer la liste
                                  </el-button>
                                </div>
                              </el-col>
                            </v-flex>

                            <v-flex xs3>
                              <v-chip text-color="white" label color="green" style="font-size:12px; width:100%">
                                TOTAL ENTREE: {{totalEntree}} FCFA
                              </v-chip>
                            </v-flex>

                            <v-flex xs3>
                              <v-chip text-color="white" label color="red" style="font-size:12px; width:100%">
                                TOTAL SORTIE: {{totalSortie}} FCFA
                              </v-chip>
                            </v-flex>

                            <v-flex xs3>
                              <v-chip text-color="white" label color="primary" style="font-size:13px; width:100%">
                                SOLDE: {{detailCaisseS.solde}} FCFA
                              </v-chip>
                            </v-flex>
                          </v-layout>

                          <!-- <data-tables ref="multipleTable1" :data="listOperation" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width: 100%">
                            <el-table-column prop="ref" label="ID" width="100" fixed>
                            </el-table-column>
                            <el-table-column prop="date" label="Date" width="100" fixed>
                            </el-table-column>
                            <el-table-column prop="libelle" label="Libellé" width="280" fixed>
                            </el-table-column>
                            <el-table-column prop="initiateur" label="Initiateur" width="220">
                            </el-table-column>
                            <el-table-column prop="validateur" label="Validateur" width="220">
                            </el-table-column>

                            <el-table-column label="OPERATION">
                              <el-table-column
                                      prop="entree"
                                      label="ENTREE"
                                      width="120">
                              </el-table-column>
                              <el-table-column
                                      prop="sortie"
                                      label="SORTIE"
                                      width="120">
                              </el-table-column>
                            </el-table-column>

                            <el-table-column prop="solde" label="Solde" width="150">
                            </el-table-column>
                          </data-tables> -->


                             <data-tables ref="multipleTable" :data="listOperation" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width: 100%">
                            <el-table-column prop="ref" label="ID" width="100" fixed>
                            </el-table-column>
                            <el-table-column prop="date" label="Date" width="100" fixed>
                            </el-table-column>
                            <el-table-column prop="libelle" label="Libellé" width="280" fixed>
                            </el-table-column>
                            <el-table-column prop="initiateur" label="Initiateur" width="220">
                            </el-table-column>
                            <el-table-column prop="validateur" label="Validateur" width="220">
                            </el-table-column>
                             <el-table-column label="OPERATION">
                              <el-table-column
                                      prop="entree"
                                      label="ENTREE"
                                      width="120">
                              </el-table-column>
                              <el-table-column
                                      prop="sortie"
                                      label="SORTIE"
                                      width="120">
                              </el-table-column>
                            </el-table-column>

                            <el-table-column prop="solde" label="Solde" width="150">
                            </el-table-column>
                          </data-tables>

                        </el-card>
                      </v-container>
                    </el-row>
                  </div>
                  <br/>
                </el-row>
              </v-flex>
            </v-layout>
          </v-container>

          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="dialogShow = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn v-if="droitAcces.edit_caisse" slot="activator" icons color="primary" @click.stop="editCaisse(detailCaisse);" dark>Modifier <v-icon right>edit</v-icon></v-btn>
            Modifier
          </v-tooltip>
          <v-tooltip top>
            <v-btn v-if="droitAcces.new_appro_caisse" slot="activator" icons color="indigo" @click.stop="newAppro(detailCaisse);" dark>Appro caisse <v-icon right>get_app</v-icon></v-btn>
            Approvisionner la caisse
          </v-tooltip>
           <v-tooltip top>
            <v-btn v-if="droitAcces.new_appro_caisse" slot="activator" icons color="grey" @click.stop="newTransfert(detailCaisse);" dark>Transfert <v-icon right>transfer_within_a_station</v-icon></v-btn>
            Tranfert de fond dans une autre trésorerie
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW REGLEMENT -->
    <v-dialog v-model="dialogShowReglement" max-width="70%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Détails du reglement {{detailReglement.ref}} de la facture {{detailReglement.refFact}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowReglement = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content bg-purple">
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md6>
                          <p><b>Identifiant : </b> {{detailReglement.ref}} </p>
                          <p><b>Facture : </b> {{detailReglement.refFact}} </p>
                          <p><b>Caisse : </b> {{detailReglement.caisse}} </p>
                          <p><b>Montant : </b>
                            <v-chip text-color="white" label color="primary">
                              {{detailReglement.montant}} FCFA
                            </v-chip>
                          </p>
                          <p><b>Etat : </b>
                            <v-chip v-if="!detailReglement.etat" text-color="white" label color="red">
                              IMPAYE
                            </v-chip>
                            <v-chip v-if="detailReglement.etat" text-color="white" label color="green">
                              PAYE
                            </v-chip>
                          </p>
                          <p><b>Mode de paiement : </b>
                            <v-chip v-if="detailReglement.mode === 1" outline text-color="primary" label color="primary">
                              Espèce
                            </v-chip>
                            <v-chip v-else-if="detailReglement.mode === 2" outline text-color="primary" label color="primary">
                              Chèque
                            </v-chip>
                            <v-chip v-else-if="detailReglement.mode === 3" outline text-color="primary" label color="primary">
                              Mobile money
                            </v-chip>
                          </p>
                          <p v-if="detailReglement.banque !== null"><b>Banque / Réseau mobile : </b> {{detailReglement.banque}}</p>
                        </v-flex>
                        <v-flex md6>
                          <p v-if="detailReglement.reference !== null"><b>Référence : </b> {{detailReglement.reference}}</p>
                          <p><b>Paiement : </b>
                            <v-chip v-if="detailReglement.partiel === true" text-color="white" label color="orange">
                              PARTIEL
                            </v-chip>
                            <v-chip v-else-if="detailReglement.partiel === false" text-color="white" label color="green">
                              TOTAL
                            </v-chip>
                          </p>
                          <p><b>Date du paiement : </b> {{detailReglement.date}}</p>
                          <p><b>Récuperé par : </b>
                            <v-chip v-if="detailReglement.effectue === 1" text-color="white" label color="secondary">
                              {{detailReglement.concerne}}
                            </v-chip>
                            <v-chip v-else-if="detailReglement.effectue === 2" text-color="white" label color="secondary">
                              {{detailReglement.remettant}}
                            </v-chip>
                          </p>
                          <p><b>Enregistré par : </b> {{detailReglement.userCreated}} </p>
                          <p><b>Date d'enregistrement : </b> {{detailReglement.created}} </p>
                          <p><b>Date de modification : </b> {{detailReglement.modified}} </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br/>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="dialogShowReglement = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn v-if="detailReglement.etat === false" slot="activator" icons color="primary" @click.stop="editRegement(detailReglement);" dark>Modifier <v-icon right>edit</v-icon></v-btn>
            Modifier
          </v-tooltip>

        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW APPROVISIONNEMENT -->
    <v-dialog v-model="dialogShowAppro" max-width="70%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="indigo">
          <v-toolbar-title>Détails de l'approvisionnement {{detailAppro.ref}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowAppro = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content bg-purple">
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md6>
                          <p><b>Identifiant : </b> {{detailAppro.ref}} </p>
                          <p><b>Caisse débité: </b> {{detailAppro.caisseDebiter}} </p>
                          <p><b>Caisse crédité : </b> {{detailAppro.caisse}} </p>
                          <p><b>Motif : </b> {{detailAppro.motif}} </p>
                          <p><b>Montant : </b>
                            <v-chip text-color="white" label color="primary">
                              {{detailAppro.montant}} FCFA
                            </v-chip>
                          </p>
                          <p><b>Etat : </b>
                            <v-chip v-if="detailAppro.etat === true" outline text-color="green" label color="green">
                              TRAITE
                            </v-chip>
                            <v-chip v-else-if="detailAppro.etat === false" outline text-color="primary" label color="primary">
                              EN ATTENTE DE VALIDATION
                            </v-chip>
                            <v-chip v-if="detailAppro.valide === 1" text-color="white" label color="green">
                              DEMANDE AUTORISE
                            </v-chip>
                            <v-chip v-else-if="detailAppro.valide === 2" text-color="white" label color="red">
                              DEMANDE REFUSE
                            </v-chip>
                          </p>
                        </v-flex>
                        <v-flex md6>
                          <p><b>Initiateur : </b> {{detailAppro.initiateur}}</p>
                          <p><b>Validateur : </b> {{detailAppro.validateur}}</p>
                          <p v-if="detailAppro.remarque != ''"><b>Commentaire : </b> {{detailAppro.remarque}} </p>
                          <p><b>Date d'enrégistrement : </b> {{detailAppro.created}} </p>
                          <p><b>Date de modification : </b> {{detailAppro.modified}} </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br/>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="dialogShowAppro = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn v-if="detailAppro.valide === 0 && detailAppro.etat === false" slot="activator" icons color="primary" @click.stop="editAppro(detailAppro);" dark>Modifier <v-icon right>edit</v-icon></v-btn>
            Modifier
          </v-tooltip>
          <!-- <v-tooltip top>
            <v-btn v-if="detailAppro.valide === 0" slot="activator" icons color="green" @click.stop="newValideAppro(detailAppro);" dark>Répondre à la demande <v-icon right>done_all</v-icon></v-btn>
            Répondre à la demande d'approvisionnement de la caisse
          </v-tooltip> -->
          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="imprimerAppro(detailAppro);" dark>Imprimer <v-icon right>print</v-icon></v-btn>
            Imprimer l'approvisionnement
          </v-tooltip>

        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW RETOUR CAISSE -->
    <v-dialog v-model="dialogRetour" max-width="70%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="indigo">
          <v-toolbar-title  v-if="detailRetour.etatretour != 1">Effectuer un retour de caisse suite au {{detailRetour.idPai}}</v-toolbar-title>
          <v-toolbar-title  v-if="detailRetour.etatretour == 1">Détails sur le retour de caisse suite au  {{detailRetour.idPai}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogRetour = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <v-alert  :value="true" outline color="purple" icon="info">
                Informations générales sur la demande
              </v-alert>
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content bg-purple">
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md6>
                          <p><b>Identifiant facture : </b> {{detailRetour.idFact}} </p>
                          <p><b>Concerné : </b> {{detailRetour.concerne}} FCFA</p>
                          <p><b>Montant Payé : </b>
                            <v-chip outline text-color="green" label color="red">
                              {{detailRetour.montant}} FCFA
                            </v-chip> </p>
                          <p><b>Etat : </b>
                            <v-chip outline text-color="red" label color="red">
                              {{detailRetour.etat}}
                            </v-chip> </p>
                        </v-flex>
                        <v-flex md6>
                          <p><b>Date de paiement </b> {{detailRetour.date}}</p>
                          <p><b>Enregistrer par : </b> {{detailRetour.userCreated}}</p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </el-card>
              </el-row>

              <v-alert :value="true" outline color="purple" icon="info" >
                Détails sur le retour dans la caisse
              </v-alert>
              <el-row>
                <el-card class="box-card">
                  <v-layout row justify v-if="detailRetour.etatretour == 1">
                    <v-flex md6>
                      <p v-if="detailRetour.etatretour == 1"><b>Montant retourné : </b>
                        <v-chip outline text-color="green" label color="green">
                          {{detailRetour.motantretour}}  FCFA
                        </v-chip>
                      </p>
                      <p><b>Date d'enrregistrement : </b> {{detailRetour.dateretour}} </p>
                    </v-flex>
                    <v-flex md6>
                      <p><b>Motif du retour : </b>
                        <v-chip outline text-color="orange" label color="green">
                          {{detailRetour.commentaire}}
                        </v-chip>
                      </p>
                      <p><b>Effectué par : </b> {{detailRetour.userRetour}} </p>
                    </v-flex>
                  </v-layout>

                  <v-card-text>
                    <el-form   v-if="detailRetour.etatretour != 1" :model="retourForm" :rules="rulesRetour" ref="retourForm" id="retourForm" label-width="100px" class="demo-ruleForm">
                      <el-form-item label="Montant" prop="montant">
                        <el-input type="number" name="montanRetour" v-model="retourForm.montant" width="80px"></el-input>
                      </el-form-item>

                      <el-form-item label="Motif" prop="commentaire">
                        <el-input
                                type="textarea"
                                name="commentaire"
                                :rows="5"
                                placeholder="Motif"
                                v-model="retourForm.commentaire">
                        </el-input>
                      </el-form-item>
                    </el-form>
                  </v-card-text>
                </el-card>
              </el-row>
              <v-tooltip top>
                <v-btn slot="activator" icons color="orange" @click.stop="dialogRetour = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
                Fermer
              </v-tooltip>
              <v-tooltip top v-if="detailRetour.etatretour != 1">
                <v-btn slot="activator" icons color="primary" @click="validRetour = true" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                Ajouter
              </v-tooltip>
            </div>
            <br/>
          </el-row>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL LISTE REGLEMENT -->
    <v-dialog v-model="dialogLoadReglement"  max-width="95%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>Liste des reglements de la facture {{factureCourant.ref}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeLoadReglement()" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <!-- TOTAL -->
          <v-container fluid grid-list-md>
            <v-layout row v-if="totalretour == 0">
              <v-flex md4 v-if="payeFacture != 0">
                <p align="center">
                  <v-chip text-color="white" label color="primary" style="font-size:18px; width:100%">
                    TOTAL A REGLER : {{totalFacture}} FCFA
                  </v-chip>
                </p>
              </v-flex>
              <v-flex md4>
                <p align="center">
                  <v-chip text-color="white" label color="green" style="font-size:18px; width:100%">
                   PAYE : {{payeFacture}} FCFA
                  </v-chip>
                </p>
              </v-flex>
              <v-flex md4>
                <p align="center">
                  <v-chip text-color="white" label color="red" style="font-size:18px; width:100%">
                    RESTANT : {{impayeFacture}} FCFA
                  </v-chip>
                </p>
              </v-flex>
            </v-layout>

            <v-layout row v-if="this.totalretour != 0 ">
              <v-flex md3 v-if="payeFacture != 0">
                <p align="center">
                  <v-chip text-color="white" label color="primary" style="font-size:18px; width:100%">
                    TOTAL A REGLER : {{totalFacture}} FCFA
                  </v-chip>
                </p>
              </v-flex>
              <v-flex md3>
                <p align="center">
                  <v-chip text-color="white" label color="green" style="font-size:18px; width:100%">
                   PAYE : {{payeFacture}} FCFA
                  </v-chip>
                </p>
              </v-flex>
              <v-flex md3>
                <p align="center">
                  <v-chip text-color="white" label color="red" style="font-size:18px; width:100%">
                    RESTANT : {{impayeFacture}} FCFA
                  </v-chip>
                </p>
              </v-flex>

              <v-flex md3>
                <p align="center">
                  <v-chip text-color="white" label color="orange" style="font-size:18px; width:100%">
                    RETOURNE : {{totalretour}} FCFA
                  </v-chip>
                </p>
              </v-flex>

            </v-layout>
          </v-container>
          <!-- SOLDE -->
          <p align="center">
            <v-chip v-if="factureCourant.etatReglFact === true" outline text-color="green" label color="green" style="font-size:22px; width:100%">
              FACTURE SOLDE <v-icon right>check</v-icon>
            </v-chip>
          </p>

          <p align="center" v-if="factureCourant.etatPaiement == false">
            <v-chip outline text-color="orange" label color="orange" style="font-size:22px; width:100%">
              LE DERNIER PAIMENT EFFECTUER N'A PAS ENCORE ETE ENCAISSE PAR LE FOURNISSEUR <v-icon right>add_alert</v-icon>
            </v-chip>
          </p>
          <div v-if="listReglement.length === 0">
            <p align="center">
              <v-chip outline text-color="orange" label color="orange" style="font-size:22px; width:100%">AUCUN PAIEMENT N'A ENCORE ETE EFFECTUE SUR CETTE FACTURE <v-icon right>add_alert</v-icon>
              </v-chip>
            </p>
          </div>

          <!-- BTN AJOUT REGLEMENT -->
          <v-spacer></v-spacer>
          <div class="text-xs-right"  v-if="this.totalFacture != 0 && this.soldeCaisse != 0 && (factureCourant.etatPaiement == null || factureCourant.etatPaiement == true) && factureCourant.etatReglFact == false && this.soldeCaisse ">
            <v-tooltip top>
              <v-btn :disabled="impayeFacture == 0"  v-if="droitAcces.edit_reglement" slot="activator" icons color="primary" @click.stop="newReglement(factureCourant, typeF)" dark>Ajouter <v-icon right>add</v-icon></v-btn>
              Ajouter un nouveau paiement
            </v-tooltip>
          </div>

          <!-- AJOUTER REGLEMENT -->
          <el-row :gutter="20" v-if="this.soldeCaisse != 0 && factureCourant.etatPaiement == null || factureCourant.etatPaiement == true && dialogAjoutReglement == true  && dialogEdit == false && factureCourant.etatReglFact == false && this.soldeCaisse != 0">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div>
                    <p align="center">
                      <v-chip v-if="dialogEdit != true" text-color="white" label color="primary" style="font-size:22px; width:100%">AJOUT D'UN NOUVEAU PAIEMENT <v-icon right>local_atm</v-icon>
                      </v-chip>
                      <v-chip v-if="dialogEdit" text-color="white" label color="primary" style="font-size:22px; width:100%">MODIFIER LE PAIEMENT PAIE-{{reglementCourant.id}} <v-icon right>local_atm</v-icon>
                      </v-chip>
                    </p>

                    <v-form v-model="valid" ref="formReglement" lazy-validation id="formReglement">
                      <v-container fluid grid-list-md>
                        <v-layout row>
                          <v-flex md4>
                            <div class="block">
                              <span class="demonstration">Montant à verser *</span>
                              <el-input-number  :readonly="readInput" :min="0" :max="totalFacture1" name="montantVerse" placeholder="Montant à verser" v-model="montantVerse" style="width:100%"></el-input-number>
                            </div>
                          </v-flex>
                          <v-flex md4>
                            <div class="block">
                              <span class="demonstration">Remis à ? *</span>
                              <el-select :disabled="readInput"  filterable v-model="selectEffectue" placeholder="Effectué par" style="width:100%">
                                <el-option v-for="item in effectue" :key="item.value" :label="item.text" :value="item.value">
                                </el-option>
                              </el-select>
                            </div>
                          </v-flex>
                          <v-flex md4>
                            <div class="block">
                              <span class="demonstration">Mode de paiement *</span>
                              <el-select  :disabled="readInput"  v-if="caisseCourant.type == 'Caisse'" filterable v-model="selectMode" placeholder="Mode de paiement" style="width:100%">
                                <el-option v-for="item in mode" :key="item.value" :label="item.text" :value="item.value">
                                </el-option>
                              </el-select>
                              <el-select v-if="caisseCourant.type == 'Banque'" filterable v-model="selectMode" placeholder="Mode de paiement" style="width:100%">
                                <el-option v-for="item in modeBanque" :key="item.value" :label="item.text" :value="item.value">
                                </el-option>
                              </el-select>
                            </div>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex md4 v-if="selectEffectue == 2">
                            <div class="block">
                              <span class="demonstration">Nom du remettant *</span>
                              <el-input name="remettant" placeholder="Nom du remettant" v-model="remettant" style="width:100%"></el-input>
                            </div>
                          </v-flex>
                          <v-flex md4 v-if="selectMode == 2 || selectMode == 3">
                            <div class="block">
                              <span class="demonstration">Banque / Réseau mobile *</span>
                              <el-input name="banque" placeholder="Banque / Réseau mobile" v-model="banque" style="width:100%"></el-input>
                            </div>
                          </v-flex>
                          <v-flex md4 v-if="selectMode == 2 || selectMode == 3">
                            <div class="block">
                              <span class="demonstration">Référence *</span>
                              <el-input name="reference" placeholder="Référence" v-model="reference" style="width:100%"></el-input>
                            </div>
                          </v-flex>
                          <v-flex md4 v-if="selectMode == 2">
                            <div class="block">
                              <span class="demonstration">Encaissé ? *</span>
                              <el-select filterable v-model="selectEncaisse" placeholder="Encaissé" style="width:100%">
                                <el-option v-for="item in encaisse" :key="item.value" :label="item.text" :value="item.value">
                                </el-option>
                              </el-select>
                            </div>
                          </v-flex>
                        </v-layout>
                        <br>

                        <v-btn @click.stop="dialogAjoutReglement = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                        <v-btn icons color="blue" @click="validPaiem = true" :disabled="!valid" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                      </v-container>
                    </v-form>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br/>
          </el-row>

          <!-- EDIT REGLEMENT -->
          <el-row :gutter="20" v-if="dialogEdit === true && dialogEditReglement === true">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div>
                    <p align="center">
                      <v-chip v-if="dialogEdit" text-color="white" label color="primary" style="font-size:22px">MODIFIER LE PAIEMENT PAIE-{{reglementCourant.id}} <v-icon right>local_atm</v-icon>
                      </v-chip>
                    </p>

                    <v-form v-model="valid" ref="formReglement" lazy-validation id="formReglement">
                      <v-container fluid grid-list-md>
                        <v-layout row>
                          <v-flex md4>
                            <div class="block">
                              <span class="demonstration">Montant à verser *</span>
                              <el-input type="number" :min="0" :max="impayeFacture1" name="montantVerse" placeholder="Montant à verser" v-model="montantVerse" style="width:100%"></el-input>
                            </div>
                          </v-flex>
                          <v-flex md4>
                            <div class="block">
                              <span class="demonstration">Effectué par ? *</span>
                              <el-select filterable v-model="selectEffectue" placeholder="Effectué par" style="width:100%">
                                <el-option v-for="item in effectue" :key="item.value" :label="item.text" :value="item.value">
                                </el-option>
                              </el-select>
                            </div>
                          </v-flex>
                          <v-flex md4>
                            <div class="block">
                              <span class="demonstration">Mode de paiement *</span>
                              <el-select filterable v-model="selectMode" placeholder="Mode de paiement" style="width:100%">
                                <el-option v-for="item in mode" :key="item.value" :label="item.text" :value="item.value">
                                </el-option>
                              </el-select>
                            </div>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex md3 v-if="selectEffectue == 2">
                            <div class="block">
                              <span class="demonstration">Nom du remettant *</span>
                              <el-input name="remettant" placeholder="Nom du remettant" v-model="remettant" style="width:100%"></el-input>
                            </div>
                          </v-flex>
                          <v-flex md3 v-if="selectMode == 2 || selectMode == 3">
                            <div class="block">
                              <span class="demonstration">Banque / Réseau mobile *</span>
                              <el-input name="banque" placeholder="Banque / Réseau mobile" v-model="banque" style="width:100%"></el-input>
                            </div>
                          </v-flex>
                          <v-flex md3 v-if="selectMode == 2 || selectMode == 3">
                            <div class="block">
                              <span class="demonstration">Référence *</span>
                              <el-input name="reference" placeholder="Référence" v-model="reference" style="width:100%"></el-input>
                            </div>
                          </v-flex>
                          <v-flex md3 v-if="selectMode == 2">
                            <div class="block">
                              <span class="demonstration">Encaissé ? *</span>
                              <el-select filterable v-model="selectEncaisse" placeholder="Encaissé" style="width:100%">
                                <el-option v-for="item in encaisse" :key="item.value" :label="item.text" :value="item.value">
                                </el-option>
                              </el-select>
                            </div>
                          </v-flex>
                        </v-layout>

                        <v-btn @click.stop="dialogEditReglement = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                        <v-btn icons color="blue" @click="submitReglement()" :disabled="!valid" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                      </v-container>
                    </v-form>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br/>
          </el-row>

          <!-- LISTE REGLEMENT -->
          <el-row :gutter="20" v-if="listReglement.length !== 0">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div>
                    <data-tables ref="multipleTable" :data="listReglement" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width: 100%">
                      <el-table-column prop="ref" label="Référence" width="280" fixed>
                        <template slot-scope="scope">
                          <v-chip text-color="white" label color="primary">
                            {{scope.row.ref}}
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column prop="etat" label="Etat" width="220">
                        <template slot-scope="scope">
                          <v-chip v-if="scope.row.etat === false" text-color="white" label color="red">
                            IMPAYE
                          </v-chip>
                          <v-chip v-else text-color="white" label color="green">
                            PAYE
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column prop="montant" label="Montant" width="240">
                        <template slot-scope="scope">
                          <v-chip text-color="white" label color="secondary">
                            {{scope.row.montant}} FCFA
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column prop="date" label="Date de paiement" width="240">
                        <template slot-scope="scope">
                          <v-chip text-color="white" label color="secondary">
                            {{scope.row.date}}
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column label="Actions" width="240">
                        <template slot-scope="scope">
                          <v-btn  icons color="green" @click="showReglement(scope.row)" fab dark small> <v-icon>folder_open</v-icon>
                          </v-btn>
                          <v-btn v-if="scope.row.etat === false" icons color="primary" @click="editRegement(scope.row)" fab dark small> <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn  icons color="indigo" @click="showPieceJustifi(scope.row)"  fab dark small> <v-icon>photo_camera</v-icon>
                          </v-btn>
                          <v-btn  icons color="orange" @click="imprimerReglement(scope.row)" fab dark small> <v-icon>print</v-icon>
                          </v-btn>

                          <v-btn v-if="scope.row.typeFacture == 3" icons color="blue" @click="retourCaisse(scope.row, scope.row.typeFacture)" fab dark small> <v-icon>arrow_back</v-icon>
                          </v-btn>
                        </template>
                      </el-table-column>
                    </data-tables>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br/>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="closeLoadReglement()" dark>Fermer <v-icon right>close</v-icon></v-btn>
            Fermer
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION -->
    <v-dialog v-model="dialogSupr" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h3 align="center">Voulez-vous vraiment supprimer cette trésorerie ?</h3>
          <p align="center">
            <v-btn @click.native="dialogSupr = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="red" @click.stop="deleteCaisse" dark>Supprimer <v-icon right>delete</v-icon></v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

     <!-- MODAL AJOUT PIECE JUSTIFICATIVE -->
     <v-dialog v-model="dialogShowPiece" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Ajouter une piece justificative</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowPiece = false;showButtonPiece=false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content bg-purple">
                    <div class="text item">
                      <v-form v-model="valid" ref="formPieceJointe" lazy-validation id="formPieceJointe">
                      <v-layout row justify>
                          <v-flex md12>
                            <p class="font-weight-thin" >Format (JPEG,PNG,PDF), 10 Mo maximum</p>
                              <a :href="pieceJusti" target="_blank">
                                <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="pieceJusti" alt="avatar"></v-avatar><br/>
                            </a>
                              <input name="photo" type="file" style="display:none" ref="fileLogo" accept="image/*" @change="onFileImageLogoPicked"/>
                                <v-btn v-if="showButtonPiece==true" color="primary" class="white--text" required @click.native="$refs.fileLogo.click()">Document  <v-icon right dark>cloud_upload</v-icon></v-btn><br/>
                          </v-flex>
                        </v-layout>
                       </v-form>
                    </div>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br/>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="dialogShowPiece = false;showButtonPiece=false" dark>Fermer <v-icon right>close</v-icon></v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn v-if="showButtonPiece === false" slot="activator" icons color="primary" @click.stop="showButtonPiece=true" dark>Modifier <v-icon right>edit</v-icon></v-btn>
            Modifier
          </v-tooltip>
          <v-tooltip top>
            <v-btn v-if="showButtonPiece === true" slot="activator" icons color="primary" @click.stop="savePieceJointe();" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
            Enregistrer
          </v-tooltip>

        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

  <!-- MODAL TRANSFERT -->
    <v-dialog v-model="validTransfert" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h1 align="center">Voulez-vous vraiment effectuer un transfert d'un montant de  {{new Intl.NumberFormat().format(this.transFertForm.montantTransf)}} FCFA</h1>
          <p align="center">
            <v-btn @click.native="validTransfert = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="red"  @click="submitTransferCaisse()" dark>Confirmer <v-icon right>check</v-icon></v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL PAIEMENT -->
    <v-dialog v-model="validPaiem" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h1 align="center">Voulez-vous vraiment effectuer un paiement d'un montant de  {{new Intl.NumberFormat().format(this.montantVerse)}} FCFA</h1>
          <p align="center">
            <v-btn @click.native="validPaiem = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="red"  @click="submitReglement()" dark>Confirmer <v-icon right>check</v-icon></v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

     <!-- MODAL RETOUR CAISSE -->
    <v-dialog v-model="validRetour" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h1 align="center">Voulez-vous vraiment effectuer un retour caisse d'un montant de  {{new Intl.NumberFormat().format(this.retourForm.montant)}} FCFA</h1>
          <p align="center">
            <v-btn @click.native="validRetour = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="red"  @click="ajouterRetour(retourForm,detailRetour)" dark>Confirmer <v-icon right>check</v-icon></v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION APPROVISIONNEMENT -->
    <v-dialog v-model="dialogSuprAppro" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">Voulez-vous vraiment supprimer cet enrégistrement ?</h6>
          <p align="center">
            <v-btn @click.native="dialogSuprAppro = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="red" @click.stop="deleteAppro" dark>Supprimer <v-icon right>delete</v-icon></v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL TRESORERIE BANQUE -->
    <v-dialog v-model="dialogModalBanque" fullscreen hide-overlay  :overlay="true" transition="dialog-bottom-transition">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialogModalBanque = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Détails de la trésorerie</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click="dialogModalBanque = false">Fermer</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <ModalBanque @close="dialogModalBanque = false" :statCaisse2="statCaisse2" :dialogModalBanque="dialogModalBanque" :listApproDgCheq="listApproDgCheq" :detailBanque="detailCaisseS" :montantEntree="montantEntree"
                   :montantSortie="montantSortie" :tableOpera="tableOpera" :formRech="formRech" :searchOpera="searchOpera" :approCourant="approCourant"
                   :newAppro="newAppro"  :newTransfert="newTransfert" :dialogAjoutAppro="dialogAjoutAppro" :listApproBanque="listApproCaisse" :showAppro="showAppro" :imprimeHistoBanque="imprimeHistoCaisse"
                   :editAppro="editAppro" :imprimerAppro="imprimerAppro" :handleCommand="handleCommand" :handleClick="handleClick" :disabledBtn="disabledBtn"
                   :listOperation="listOperation" :dateOperation="dateOperation" :totalEntree="totalEntree" :totalSortie="totalSortie" :imprimeListeHis="imprimeListeHis">
      </ModalBanque>
    </v-dialog>

    <!-- TABLEAU -->
    <v-card>
      <div>
        <v-card-title>
          <v-chip text-color="white" label color="primary">
            LISTE DES TRESORERIES <v-icon right>account_balance</v-icon>
          </v-chip>
          <v-spacer></v-spacer>
          <br /><br />
         <div>
          <el-select filterable clearable @clear="clearSelect()"  @change="filtrerCaisseDmd" v-model="selectCaisseDmd" placeholder="Selectionner une caisse">
                <el-option
                        v-for="item in listCaisse"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id">
                </el-option>
            </el-select>
          </div>
        </v-card-title>

        <v-card-text>
          <v-data-table  v-bind:headers="headers" v-bind:search="search" :items="listCaisse" class="elevation-1">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip top>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" scope="props">
              <td v-if="!props.item.libelleFull" class="text-xs-center"> {{ props.item.libelle }} </td>
              <td v-if="props.item.libelleFull" class="text-xs-center"> {{ props.item.libelleFull }} </td>
              <td class="text-xs-center">
                <v-chip text-color="white" label color="primary">
                  {{ props.item.gerant }} <v-icon right>perm_identity</v-icon>
                </v-chip>
              </td>
              <td class="text-xs-center">
                <v-chip v-if="!props.item.etat" text-color="white" label color="red">
                  FERME
                </v-chip>
                <v-chip v-if="props.item.etat" text-color="white" label color="green">
                  OUVERT
                </v-chip>
              </td>
              <td class="text-xs-center">
                <v-chip outline text-color="primary" label color="primary">
                  {{ props.item.solde }} FCFA <v-icon right>local_atm</v-icon>
                </v-chip>
              </td>
              <td class="text-xs-center">
                <div class="text-xs-center">
                  <v-tooltip top>
                    <v-btn v-if="props.item.etat === true && props.item.type === 'Caisse'" slot="activator" @click.stop="showCaisse(props.item); loadAppro(props.item); loadOperation(props.item); loadOperationsCaisse(props.item.id); loadProjet(props.item)" fab dark small color="green">
                      <v-icon dark>folder_open</v-icon>
                    </v-btn>
                    Détails
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn v-if="props.item.type === 'Banque'" @click.stop="showBanque(props.item); loadListApproDgCheqBanque(props.item.id); loadAppro(props.item); loadOperation(props.item); loadOperationsCaisse(props.item.id); loadProjet(props.item)" slot="activator"  fab dark small color="orange">
                      <v-icon dark>folder_open</v-icon>
                    </v-btn>
                    Details Banque
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn  slot="activator" @click.stop="editCaisse(props.item)" fab dark small color="blue">
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                    Modifier
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn v-if="droitAcces.caisse_delete" slot="activator" @click.stop="dialogSupr = true; idCaisse = props.item.id;" fab dark small color="red">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                    Supprimer
                  </v-tooltip>
                </div>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </div>
    </v-card>

  </div>
</template>

<script>
    var echarts = require('echarts/lib/echarts')
    require('echarts/lib/chart/bar')
    require('echarts/lib/chart/pictorialBar')
    require('echarts/lib/chart/funnel')
    require('echarts/lib/chart/sankey')
    require('echarts/lib/chart/scatter')
    require('echarts/lib/chart/pie')
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')
    import Loading from '@/components/Loading';
    import ModalBanque from '@/components/Tresorerie/ModalBanque'

    export default {
        components:{ Loading, ModalBanque},
        name: 'app',
        data () {
            return {
                loading: false,
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                headers: [
                    { text: 'Désignation', align: 'center', sortable: true, value: '' },
                    { text: 'Gérant', align: 'center',sortable: true, value: '' },
                    { text: "Etat", align: 'center',sortable: true, value: '' },
                    { text: "Solde", align: 'center',sortable: true, value: '' },
                    { text: 'Actions', align: 'center', value: '' }
                ],
                items: [
                    {value: false, designation: '', gerant: '', etat: '', solde: '', action: ''}
                ],
                racourcis: [
                    { path: '/', text: 'Accueil', disabled: false },
                    { path: '/entepot', text: 'Liste des caisses', disabled: true }
                ],
                search: '',
                formRech: {
                    recherche: '',
                },
                approForm: {
                    motif: '',
                    montant: '',
                },
                transFertForm: {
                  montantTransf: '',
                  libelleTransfert: '',
                  caisseSelect: '',
                },
                retourForm: {
                    motif: '',
                    montant: '',
                },
                rulesRetour: {
                    commentaire: [
                        { required: true, message: 'Veuillez saisir le commentaire', trigger: 'blur' },
                    ],
                    montant: [
                        { required: true, message: 'Veuillez saisir le montant', trigger: 'blur' },
                    ],
                },
                rulesAppro: {
                    motif: [
                        { required: true, message: 'Veuillez saisir le motif', trigger: 'blur' },
                    ],
                    montant: [
                        { required: true, message: 'Veuillez saisir le montant', trigger: 'blur' },
                    ],
                },
                rulesTransfer: {
                    caisse: [
                        { required: true, message: 'Veuillez selectionner une caisse', trigger: 'blur' },
                    ],
                    motif: [
                        { required: true, message: 'Veuillez saisir le motif', trigger: 'blur' },
                    ],
                    montant: [
                        { required: true, message: 'Veuillez saisir le montant', trigger: 'blur' },
                    ],
                },
                pieceJusti: '',
                dialogAjout: false,
                dialogAjoutReglement: false,
                dialogAjoutAppro: false,
                dialogAjoutTrans: false,
                dialogAjoutValideAppro: false,
                dialogEditReglement: false,
                dialogEdit: false,
                showButtonPiece: false,
                dialogShow: false,
                totalretour: 0,

                dialogAjoutDepense: false,
                nature: '',

                dialogShowReglement: false,
                dialogShowPiece: false,
                optionPaiement: '',
                dialogShowAppro: false,
                dialogRetour: false,
                dialogLoadReglement: false,
                dialogSupr: false,
                validPaiem: false,
                validTransfert: false,
                validRetour: false,
                dialogSuprAppro: false,
                dialogModalBanque: false,
                valid: true,
                users: [],
                selectAdmin: "",
                seuilMax: 5,
                fileLogo: '',
                seuilMin : 5,
                categorie: "",
                soldeInitial : 0,
                numCompte: 'O',
                libelle: '',
                activer: false,
                idCaisse: '',
                listCaisse: [],
                listCaisseTransfert: [],
                oldListCaisses:[],
                selectCaisseDmd:'',
                tableOpera: [],
                statBanque: [],
                caisseCourant: [],
                detailCaisse: [],
                detailCaisseS: [],
                libelleCaisse:'',
                dateFacture: "",
                dateOperation: "",
                montant: '',
                demandeur: '',
                selectEtatDepense: '',
                etatDepense: '',
                listDepense: [],
                selectTresor: [],
                selectTypes: [],
                listAllDepense: [],
                dialogDepense: false,
                motif: '',

                //critere de recherche
                formTri:{
                    periode:'',
                },
                dateFactureRules: [ (v) => !!v || "Veuillez renseigner les intervalles de date" ],
                dateOperationRules: [ (v) => !!v || "Veuillez renseigner les intervalles de date" ],
                selectTypeFacture: "",
                typeFacture: [
                    { text: 'Par date de création', value: 1 },
                    { text: 'Par période', value: 2 },
                ],
                selectEtatFacture: "",
                etatFacture: [
                    { text: 'Impayé', value: 0 },
                    { text: 'Soldé', value: 1 },
                    { text: 'En attente de paiement', value: 2 },
                    { text: 'En cours de paiement', value: 3 },
                ],
                listFournisseur: [],
                listProjet: [],
                listClient: [],
                selectFournisseur: "",
                selectProjet: "",
                selectClient: "",
                listFacture: [],
                totalFacture: 0,
                totalFacture1: 0,
                payeFacture: 0,
                payeFacture1: 0,
                impayeFacture: 0,
                impayeFacture1: 0,
                factureCourant: [],
                listReglement: [],
                montantVerse: 5,
                remettant: '',
                banque: '',
                reference: '',
                selectEncaisse: '',
                encaisse: [
                    { text: 'OUI', value: 1 },
                    { text: 'NON', value: 2 },
                ],
                selectEffectue: "",
                effectue: [
                    { text: 'Lui même', value: 1 },
                    { text: 'Autre', value: 2 },
                ],
                selectMode: '',
                mode: [
                    { text: 'Espèce', value: 1 },
                    //{ text: 'Mobile money', value: 3 },
                ],
                modeBanque: [
                    //{ text: 'Espèce', value: 1 },
                    { text: 'Chèque', value: 2 },
                    //{ text: 'Mobile money', value: 3 },
                ],
                reglementCourant: [],
                detailReglement: [],
                montantSortie: 0,
                montantEntree: 0,
                totalEntree: 0,
                totalSortie: 0,
                montantTvaEntree: 0,
                montantTvaSortie: 0,
                montantAppro: 5,
                libelleAppro: '',
                libelleTransfert:'',
                remarqueAppro: '',
                selectValidateurAppro: '',
                approCourant: [],
                listApproCaisse: [],
                pieceJusti: "/static/img-doc.png",

                listApproDgCheq: [],
                selectReponseAppro: '',
                reponseAppro: [
                    { text: 'Autorisé', value: 1 },
                    { text: 'Réfusé', value: 2 }
                ],
                detailAppro: [],
                detailRetour: [],
                soldeCaisse: 0,
                statAllCaisse: [],
                statCaisse: [],
                statCaisse1: [],
                statCaisse2: [],
                listResulat: [],
                showRecherche: false,
                typeF: '',
                idAppro: '',
                selectTresorerie: '',
                listeTypeF: [
                    { label: 'FOURNISSEUR/PRESTATAIRE', value: 1 },
                    { label: 'MISSION', value: 2 },
                    { label: 'INTERVENTION', value: 3 },
                    { label: 'DECAISSEMENT', value: 4 },
                    // { label: 'CLIENT', value: 5 },
                    // { label: 'PROJET', value: 6 },
                ],
                typeTresorerie: [
                    { text: 'CAISSE', value: 'Caisse' },
                    { text: 'BANQUE', value: 'Banque' }
                ],
                categorieCaisse: [
                    { text: 'Projet', value: "Projet" },
                    { text: 'Bureau', value:'Bureau'  },
                    { text: 'Maintenance', value: 'Maintenance' }
                ],
                listOperation:[],
                dateDbt: null,
                dateFin: null,
                disabledBtn : false,
                typeRech: "fournisseur",

                //Demandeur
                selectDemandeur: null,
                listeDemandeur: [],
                readInput: false
            }
        },
        computed: {
        },
        methods: {
        getSumm(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "Total";
                        return;
                    }

                    if (index === 4) {
                        sums[index] = "N/A";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });

                return sums;
            },
            handleCommand(command) {
                this.loadOperation(this.caisseCourant)
            },
            headerRowStyle({row, rowIndex}) {
                return {"color":"black"};
            },

            handleClick(){
                this.loadSearchOperation(this.caisseCourant)
            },
            loadPage () {
                this.loading = true
            },
            loadUser () {
                this.loading = true
                let url = this.domaine + 'userCreate/user-list'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.users = response.body
                        this.loading = false
                    }
                })
            },
            rechercheFacture() {

              if(this.formTri.caisse =='' && this.formTri.type =='') {
                 this.$notify({
                        title: 'Erreur...',
                        message: "Veuillez renseigner les champs obligatoires.",
                        type: 'warning',
                        position: 'top-center'
                    })
                    return;
              }
              this.loading = true
              var form = document.getElementById("formTri");
              var data = new FormData(form);
              data.append('idUser', this.user.id)
              data.append('periode', this.formTri.periode)
              data.append('tresorerie', this.selectTresor)
              data.append('type', this.selectTypes)

              // this.loading = true
              this.listResulat = []
              let  url = this.domaine + 'caisse/recherche/information'
              this.$http.post(url,data).then(response => {
                      if (response.body) {
                        let tab = response.body.recherch
                        this.listResulat = tab
                        this.showRecherche = true
                        this.$notify({
                              title: 'RESULTAT RECHERCHE',
                              message: 'Factures trouvéesavec succès.',
                              type: 'success',
                              position: 'top-center'
                          })
                        this.loading = false
                      }
                  },
                  error => {
                      this.$message.error('Sélectionnez au moins une trésorerie')
                      this.loading = false
                      this.validPaiem = false
                  })
            },
            loadFournisseur () {
                this.loading = true
                let url = this.domaine + 'fournisseur/index'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listFournisseur = response.body.fournisseur
                        this.loading = false
                    }
                })
            },
            loadProjet (ligne) {
                this.loading = true
                let url = this.domaine + 'caisse/'+ ligne.id +'/caisse/projet'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listProjet = response.body.projet
                        this.loading = false
                    }
                })
            },
            savePieceJointe() {
                   let  url = this.domaine + 'caisse/'+ this.typeF + '/' + this.optionPaiement.id + '/new/optionPaiement'
                    var form = document.getElementById("formPieceJointe");
                    var data = new FormData(form);
                    data.append('idUser', this.user.id)
                    data.append('idPiece', this.optionPaiement.idPiece)

                    this.loading = true

                    this.$http.post(url,data).then(response => {
                            if (response.body) {
                                     this.$notify({
                                            title: 'ENREGISTREMENT REUSSI',
                                            message: 'Piece jointe enregistré avec succès.',
                                            type: 'success',
                                            position: 'top-center'
                                        })

                              this.dialogShowPiece = false
                              this.showButtonPiece = false
                              this.showCaisse(this.caisseCourant)
                                this.loadRegement(this.factureCourant, this.typeF)

                              this.loading = false
                            }
                        },
                        error => {
                            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                            this.loading = false
                            this.validPaiem = false

                        })
            },
            clearSelect(){
               this.listCaisse = this.oldListCaisses
            },
            loadClient() {
                this.loading = true
                let url = this.domaine + 'client/projet/index'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listClient = response.body.client
                        this.loading = false
                    }
                }, error => {
                    this.loading = false
                })
            },
            loadFactureClient(item) {
                let url = this.domaine + "facture/client/"+item.id+"/index";
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listFacture = response.body;
                    }
                });
            },
            searchOpera () {
                if (formRech.recherche != '') {
                    var form = document.getElementById('formRech')
                    var data = new FormData(form)
                    let url = this.domaine + 'caisse/' + this.caisseCourant.id + '/search/show'
                    this.$http.post(url, data).then(response => {
                        if (response.body) {
                            this.loading = true
                            this.tableOpera = response.body.operation
                            this.loading = false
                        }
                    })

                }
            },

            loadCaisse () {
                this.loading = true
                let url = ""
                if(this.droitAcces.caisse){//pour l'admin
                    url = this.domaine + 'caisse/index'
                } else if(this.droitAcces.caisse_unique_user){//pour celui qui a crée la caisee
                    url = this.domaine + 'caisse/unique/'+ this.user.id +'/user/index'
                }else{
                    url = this.domaine + 'caisse/unique/'+ this.user.id +'/index'
                }
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.detailCaisseS = response.body.caisse
                        this.listCaisse = response.body.caisse
                        this.listCaisseTransfert = response.body.caisse
                        this.oldListCaisses =  response.body.caisse,
                        this.soldeCaisse = response.body.soldeCaisse
                        this.statAllCaisse = response.body.stats
                        this.statAllbilan()
                        this.loading = false
                    }
                })
            },

            loadOperationsCaisse (item) {
                this.loading = true
                let url = this.domaine + 'caisse/load/operations/'+ item +'/today'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.tableOpera = response.body.operations
                        this.loading = false
                    }
                })
            },
            loadFacture (ligne) {
                this.loading = true
                this.caisseCourant = ligne;
                this.listFacture = [];
                if (this.$refs.formFacture.validate()) {

                    let form = document.getElementById('formFacture')
                    let data = new FormData(form)
                    let url = this.domaine + 'caisse/' + this.caisseCourant.id + '/facture'
                    data.append('idUser', this.user.id)
                    data.append('fournisseur', this.selectFournisseur)
                    data.append('projet', this.selectProjet)
                    data.append("dateFacture", this.dateFacture)
                    data.append('type', this.selectTypeFacture)
                    data.append('typeRech', this.typeRech)
                    data.append('client', this.selectClient)
                    data.append('categorie', this.caisseCourant.categorie)

                    data.append('idDemandeur', this.selectDemandeur)
                    data.append('etat', this.selectEtatFacture)
                    this.$http.post(url, data).then(response => {
                            if (response.body) {
                                let verif = response.body
                                if (verif.code === 1) {
                                    this.listFacture = verif.facture
                                    if (this.listFacture.length === 0) {
                                        this.$notify({
                                            title: 'RESULTATS DE VOTRE RECHERCHE',
                                            message: "Aucune facture n'a été trouvée.",
                                            type: 'warning',
                                            position: 'top-center'
                                        })
                                    } else {
                                        this.$notify({
                                            title: 'RESULTATS DE VOTRE RECHERCHE',
                                            message: this.listFacture.length + " facture(s) ont été trouvée(s).",
                                            type: 'success',
                                            position: 'top-center'
                                        })
                                    }
                                } else if (verif.code === 2) {
                                    this.$message({
                                        message: verif.message,
                                        type: 'warning'
                                    })
                                    this.loading = false
                                } else if (verif.code === 3) {
                                    this.$message({
                                        message: verif.message,
                                        type: 'warning'
                                    })
                                    this.loading = false
                                } else if (verif.code === 0) {
                                    this.$message.error(verif.message)
                                    this.loading = false
                                }

                                this.loading = false
                            } else {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                            }
                        },
                        response => {
                            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                            this.loading = false
                        })
                }
            },
            loadSearchOperation (ligne) {
                this.loading = true
                this.disabledBtn = false
                this.caisseCourant = ligne
                if (this.$refs.formOperation.validate()) {
                    var form = document.getElementById('formOperation')
                    var data = new FormData(form)
                    let url = this.domaine + 'caisse/search/' + this.caisseCourant.id + '/caisse/operation'
                    this.$http.post(url, data).then(response => {
                            this.dateDbt = response.body.dateD
                            this.dateFin = response.body.dateF
                            if (response.body) {
                                let verif = response.body
                                if (verif.operation) {
                                    this.listOperation = verif.operation
                                } else {
                                    this.loading = false
                                    this.listOperation= [];
                                    this.dateDbt = 0
                                    this.dateFin = 0
                                    this.disabledBtn = true
                                    this.$message.error('Resultat de recherche vide')

                                }
                                this.loading = false
                            } else {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.dateDbt = 0
                                this.dateFin = 0
                                this.disabledBtn = true
                                this.loading = false
                            }
                        },
                        response => {
                            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                            this.loading = false
                        })
                }else {
                    this.loading = false
                    this.$message.error('Veuillez selectionner les dates')

                }
            },
            retourCaisse (ligne, type)
            {
                this.dialogRetour = true,
                this.typeF = type
                this.reglementCourant = ligne
                this.montantVerse = 5;
                // this.dialogLoadReglement = true
                let url = this.domaine + 'caisse/'+ this.reglementCourant.id +'/'+ this.user.id +'/index/retour'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.detailRetour = response.body.retour
                        
                    }
                })
            },
            loadRegement (ligne, type)
            {
                this.typeF = type
                this.factureCourant = ligne

                this.montantVerse = 5;
                this.dialogLoadReglement = true
                let url = this.domaine + 'caisse/'+ this.typeF +'/'+ this.factureCourant.idFact +'/index/reglement'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listReglement = response.body.paiement
                        this.typeF = response.body.typeF
                        if(response.body.type != 3) // si ce na'est pas un facture de demande de fonds
                        {
                            this.readInput = false;
                        }
                        else {
                            this.montantVerse = response.body.total1;
                            this.totalretour = response.body.totalretour;
                            this.selectEffectue = 1; //"Lui meme"
                            this.selectMode = 1; //"espece"
                            this.readInput = true;
                        }
                        this.totalFacture = response.body.total
                        this.totalFacture1 = response.body.total1
                        this.payeFacture = response.body.total
                        this.payeFacture1 = response.body.paye1
                        this.totalretour = response.body.totalretour;
                        this.impayeFacture = response.body.impaye
                        this.impayeFacture1 = response.body.impaye1
                        this.soldeCaisse = response.body.soldeCaisse
                        this.dialogAjoutReglement = false
                        this.dialogEditReglement = false
                        this.dialogEdit = false
                    }
                })
            },
            loadAppro (ligne) {
                this.caisseCourant = ligne
                let url = this.domaine + 'caisse/' + this.caisseCourant.id + '/index/appro/caisse'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listApproCaisse = response.body.appro
                    }
                })
            },
            loadOperation (ligne) {
                this.loading = true
                this.disabledBtn =  false
                this.dateDbt = 0
                this.dateFin = 0
                this.caisseCourant = ligne
                let url = this.domaine + 'caisse/' + this.caisseCourant.id + '/'+ this.user.id +'/operation'
                this.$http.get(url).then(response => {
                    this.loading = false
                    if (response.body.operation.length > 0) {
                        this.listOperation = response.body.operation
                    }else{
                        this.dateDbt = 0
                        this.dateFin = 0
                        this.disabledBtn =  true
                    }
                }, (response)=> {
                    this.loading = false
                    this.$message.error('Erreur lors du chargement des transactions')
                    this.dateDbt = 0
                    this.dateFin = 0
                    this.disabledBtn =  true
                })
            },
            showCaisse (ligne) {
                this.loading = true

                this.dialogShow = true
                this.caisseCourant = ligne
                this.listFacture = []
                let url = this.domaine + 'caisse/' + this.caisseCourant.id + '/show'
                this.$http.get(url).then(response => {
                    if (response.body) {
                      this.loading = false

                        this.detailCaisse = response.body.caisse
                        this.detailCaisseS = response.body.details
                        this.montantSortie = response.body.montantSortie
                        this.montantEntree = response.body.montantEntree
                        this.montantTvaEntree = response.body.montantTvaEntree
                        this.soldeCaisse = this.detailCaisseS.solde1

                        this.totalEntree = response.body.totalEntree
                        this.totalSortie = response.body.totalSortie

                        this.montantTvaSortie = response.body.montantTvaSortie
                        this.statCaisse1 = response.body.stats1
                        this.statAllbilanCaisse()
                    }
                })
            },
            showReglement (ligne) {
                this.dialogShowReglement = true
                this.reglementCourant = ligne
                let url = this.domaine + 'caisse/' + this.reglementCourant.id + '/show/reglement'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.detailReglement = response.body.paiement
                    }
                })
            },
            showAppro (ligne) {
                this.dialogShowAppro = true
                this.approCourant = ligne

                let url = this.domaine + 'caisse/' + this.approCourant.id + '/show/appro'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.detailAppro = response.body.appro
                    }
                })
            },
            newCaisse () {
                this.loading = false
                this.dialogAjout = true
                this.dialogEdit = false
                this.selectAdmin = ''
                this.seuilMax = 5
                this.seuilMin = 5
                this.libelle = ''
                this.activer = false
                this.selectTresorerie = ''
                this.caisseCourant = ''
                this.soldeInitial = ''
                this.categorie = ''
            },
            newReglement (ligne) {

                this.dialogAjoutReglement = true
                this.dialogEditReglement = false
                this.dialogEdit = false
                this.montantVerse = 5
                this.remettant = ''
                this.banque = ''
                this.reference = ''
                this.selectEncaisse = null
                this.selectEffectue = null
                this.selectMode = null
                this.readInput = false;
            },
            newTransfert(ligne) {
              this.loading = false
              this.dialogAjoutTrans = true
              this.transFertForm ={}
            },
            newAppro (ligne){
                this.loading = false

                this.dialogAjoutAppro = true

                this.dialogEdit = false
                this.approCourant = []
                this.approCourant.id = ''
                this.approForm.montant = ''
                this.approForm.motif = ''
                this.selectValidateurAppro = null
            },
            newValideAppro (ligne){
                this.loading = false
                this.approCourant = ligne
                this.dialogAjoutValideAppro = true
                this.dialogEdit = false
            },
            editCaisse (ligne) {
                this.loading = false
                this.dialogAjout = true
                this.dialogEdit = true
                this.caisseCourant = ligne
                this.selectAdmin = this.caisseCourant.idGerant
                this.seuilMax = this.caisseCourant.seuilMax
                this.seuilMin = this.caisseCourant.seuilMin
                // if (this.numCompte == null) { this.numCompte = 'O'}
                this.libelle = this.caisseCourant.libelle
                this.activer = this.caisseCourant.etat
                this.numCompte = this.caisseCourant.numCompte
                this.soldeInitial = this.caisseCourant.soldeInitial
                this.selectTresorerie = this.caisseCourant.type
                this.categorie = this.caisseCourant.categorie
            },
            editRegement (ligne) {
                this.loading = false
                this.dialogShowReglement = false
                this.dialogAjoutReglement = false
                this.dialogEditReglement = true
                this.dialogEdit = true
                this.reglementCourant = ligne
                this.montantVerse = this.reglementCourant.montant1
                this.remettant = this.reglementCourant.remettant
                this.banque = this.reglementCourant.banque
                this.reference = this.reglementCourant.reference
                this.selectEncaisse = this.reglementCourant.encaisse
                this.selectEffectue = this.reglementCourant.effectue
                this.selectMode = this.reglementCourant.mode
            },
            editAppro (ligne,) {
                this.loading = false
                this.approCourant = ligne
                this.dialogAjoutAppro = true
                this.dialogEdit = true
                this.approForm.montant = this.approCourant.montant1
                this.approForm.motif = this.approCourant.motif
                this.selectValidateurAppro = this.approCourant.idValid
            },
            ajouterRetour (ligne,detailRetour) {
                this.loading = true
                this.validRetour = false
                if (this.retourForm.montant != "" && this.retourForm.commentaire != ""){
                    var form = document.getElementById('retourForm')
                    var data = new FormData(form)
                    let url = ''
                    data.append('idUser', this.user.id)
                    data.append('idpaiement', this.detailRetour.idPaionly)
                    data.append('concerne', this.detailRetour.concerne)
                    data.append('idCaisse', this.caisseCourant.id)
                    data.append('idFacture', this.factureCourant.idFact)
                    data.append('admin', this.selectAdmin)
                    data.append('activer', this.activer)
                    data.append('categorie', this.categorie)
                    data.append('type', this.selectTresorerie)

                    url = this.domaine + 'caisse/' + this.factureCourant.idFact + '/ajout/retour'
                    this.$http.post(url, data).then(response => {
                            if (response.body) {
                                let verif = response.body
                                if (verif.code === 1) {
                                    this.$notify({
                                        title: 'ENREGISTREMENT REUSSI',
                                        message: response.body.message,
                                        type: 'success',
                                        position: 'top-center'
                                    })
                                }
                                // this.loadCaisse()
                                this.dialogRetour = false
                                this.retourForm.motif = ''
                                this.retourForm.montant = ''
                                this.loadOperation(this.caisseCourant)
                                this.loadRegement(this.factureCourant, this.typeF)
                                this.loadCaisse()
                                this.showCaisse(this.caisseCourant)
                                // this.loadRegement (this.factureCourant, this.typeF)
                                // this.showCaisse(this.caisseCourant)

                                this.loading = false
                                this.validRetour = false

                            } else {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                            }
                        },
                        response => {
                            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                            this.loading = false
                        })
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "le retour caisse n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
            changeTresor () {

                if (this.selectTresorerie === 'Banque') {
                    this.numCompte = ''
                } else{
                    this.numCompte = 'O'
                }
            },
            submitCaisse () {
                this.loading = true

                if(this.selectTresorerie == "Caisse"){
                    if (this.$refs.formCaisse.validate() && this.libelle != "" && this.selectAdmin != ""  && this.seuilMin != "" && this.seuilMax != "" && this.categorie !="" && this.numCompte != "" && (this.soldeInitial > -1 && this.soldeInitial != "") ) {
                    }
                    else{
                        this.$message.error('Veuillez renseigner les champs obligatoires')
                        this.$notify.error({
                            title: "ERREUR D'ENREGISTREMENT",
                            message: "La caisse n'a pas été enregistré.",
                            position: 'top-center'
                        })

                        this.loading = false
                    }
                }
                else if(this.selectTresorerie == "Banque"){
                    if (this.$refs.formCaisse.validate() && this.libelle != "" && this.selectAdmin != ""  && this.seuilMin != "" && this.seuilMax != "" && this.numCompte != "" && (this.soldeInitial > -1 && this.soldeInitial != "") ) {

                    }
                    else{
                        this.$message.error('Veuillez renseigner les champs obligatoires')
                        this.$notify.error({
                            title: "ERREUR D'ENREGISTREMENT",
                            message: "La caisse n'a pas été enregistré.",
                            position: 'top-center'
                        })
                        this.loading = false
                    }
                }
                else{
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La caisse n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }


                var form = document.getElementById('formCaisse')
                var data = new FormData(form)
                let url = ''
                data.append('idUser', this.user.id)
                data.append('admin', this.selectAdmin)
                data.append('activer', this.activer)
                data.append('type', this.selectTresorerie)
                data.append('categorie', this.categorie)
                if (this.caisseCourant.id) {
                    url = this.domaine + 'caisse/' + this.caisseCourant.id + '/edit'
                } else {
                    url = this.domaine + 'caisse/create'
                }
                this.$http.post(url, data).then(response => {
                        if (response.body) {
                            let verif = response.body
                            if (verif.code === 1) {
                                if (this.caisseCourant.id) {
                                    this.$notify({
                                        title: 'MODIFICATION REUSSI',
                                        message: 'Caisse modifié avec succès.',
                                        type: 'success',
                                        position: 'top-center'
                                    })
                                    this.showCaisse(this.caisseCourant)
                                } else {
                                    this.$notify({
                                        title: 'ENREGISTREMENT REUSSI',
                                        message: 'Caisse enregistré avec succès.',
                                        type: 'success',
                                        position: 'top-center'
                                    })
                                }
                                this.loadPage()
                                this.loadCaisse()
                                this.dialogAjout = false
                                this.dialogShow = false
                                this.loading = false
                            } else if (verif.code === 0) {
                                this.$message.error(verif.message)
                                this.loading = false
                            }
                        } else {
                            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                            this.loading = false
                        }
                    },
                    response => {
                        this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                        this.loading = false
                    })

            },
            submitReglement () {


                if(this.selectMode == ""  || this.selectMode== null){
                    this.$notify.error({
                        title: "MODE DE PAIEMENT",
                        message: "Veuillez selectionner le mode de paiement",
                        position: 'top-center'
                    })
                    this.validPaiem = false
                    return
                }
                this.validPaiem = false
                this.loading = true

                if(this.soldeCaisse >= this.montantVerse ){

                      if (this.montantVerse > 0 && this.montantVerse <= this.impayeFacture1) {

                        let etat = false
                        if (this.selectEffectue != "" && this.selectMode != "") {
                            if ((this.selectEffectue == 2 && this.remettant == '') || ((this.selectMode != 1 && this.selectMode == 2) && (this.banque == '' || this.reference == '' || this.selectEncaisse == ''))) {
                                etat = false
                            } else if ((this.selectEffectue == 2 && this.remettant == '') || ((this.selectMode != 1 && this.selectMode == 3) && (this.banque == '' || this.reference == ''))) {
                                etat = false
                            } else {
                                etat = true
                            }
                        } else {
                            etat = false
                        }

                        if (etat == true) {
                            if (this.$refs.formReglement.validate()) {
                                var form = document.getElementById('formReglement')
                                var data = new FormData(form)
                                let url = ''
                                data.append('idUser', this.user.id)
                                data.append('effectue', this.selectEffectue)
                                data.append('mode', this.selectMode)
                                data.append('encaisse', this.selectEncaisse)

                                    url = this.domaine + 'caisse/'+ this.typeF + '/' + this.factureCourant.idFact + '/new/reglement'
                                this.$http.post(url, data).then(response => {

                                        if (response.body) {
                                             this.dialogEditReglement = false
                                            this.dialogAjoutReglement = false
                                            let verif = response.body
                                            if (verif.code === 1) {
                                                if (this.reglementCourant.id) {
                                                    this.$notify({
                                                        title: 'MODIFICATION REUSSI',
                                                        message: response.body.message,
                                                        type: 'success',
                                                        position: 'top-center'
                                                    })
                                                } else {
                                                    this.$notify({
                                                        title: 'ENREGISTREMENT REUSSI',
                                                        message: 'Paiement enregistré avec succès.',
                                                        type: 'success',
                                                        position: 'top-center'
                                                    })
                                                }

                                                this.$refs.formReglement.reset()
                                                this.loadRegement(this.factureCourant, this.typeF)
                                                this.loadCaisse()
                                                this.showCaisse(this.caisseCourant)
                                                this.loadOperation(this.caisseCourant)

                                                this.listFacture = []
                                                this.loading = false
                                                this.dialogEdit = false
                                                // this.dialogLoadReglement = false
                                            } else if (verif.code === 0) {
                                                this.$message.error(verif.message)
                                                this.loading = false
                                            }
                                        } else {
                                            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                            this.loading = false
                                            this.validPaiem = false

                                        }
                                    },
                                    response => {
                                        this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                        this.loading = false
                                        this.validPaiem = false

                                    })
                            } else {
                                this.$message.error('Veuillez renseigner les champs obligatoires')
                                this.$notify.error({
                                    title: "ERREUR D'ENREGISTREMENT",
                                    message: "Le paiement n'a pas été enregistré.",
                                    position: 'top-center'
                                })
                                this.loading = false
                                this.validPaiem = false

                            }
                        } else {
                            this.$message.error('Veuillez renseigner les champs obligatoires')
                            this.loading = false
                            this.validPaiem = false

                        }

                      } else {
                          this.$notify.error({
                              title: "ERREUR DU MONTANT",
                              message: "Le montant versé ne doit pas etre supérieur au montant restant.",
                              position: 'top-center'
                          })
                          this.loading = false
                          this.validPaiem = false

                      }

                }else{
                   this.$notify.error({
                        title: "ERREUR DU MONTANT",
                        message: "Impossible d'effectuer un paiement, fond insuffisant dans la caisse.",
                        position: 'top-center'
                    })
                    this.loading = false
                    this.validPaiem = false
                }

            },
             filtrerCaisseDmd(idCaisse){
                 this.loadDmdParCaisse(idCaisse)
            },
             loadDmdParCaisse(idCaisse)
            {
                 this.listCaisse = this.oldListCaisses.filter(function (item) {
                  return item.id == idCaisse
            })
            },
            loadBilanFacture() {
               let url = this.domaine + 'caisse/' + this.caisseCourant.id + '/imprimer/bilan/'+this.user.id
                this.$http.get(url).then(response => {
                    if (response.body) {
                    }
                })
                window.open(url)
            },
            showBanque (ligne) {

                this.dialogModalBanque = true
                // this.dialogShow = true
                this.caisseCourant = ligne

                this.listFacture = []
                let url = this.domaine + 'caisse/' + this.caisseCourant.id + '/show'
                this.$http.get(url).then(response => {
                    if (response.body) {

                        this.detailCaisse = response.body.caisse
                        this.detailCaisseS = response.body.details
                        this.montantSortie = response.body.montantSortie
                        this.montantEntree = response.body.montantEntree
                        this.montantTvaEntree = response.body.montantTvaEntree
                        this.montantTvaSortie = response.body.montantTvaSortie
                        this.totalEntree = response.body.totalEntree
                        this.totalSortie = response.body.totalSortie
                        this.statCaisse2 = response.body.stats1
                        this.statAllbilanCaisse()
                    }
                })
            },
                //enregistrement des images
            onFileImageLogoPicked(event)
              {
               const files = event.target.files;
                let filename = files[0].name;
                if (filename.lastIndexOf(".") <= 0) {
                  return alert("Veuillez selectionner un  format de fichier valide ");
                }

                const fileReader = new FileReader();
                fileReader.addEventListener("load", () => {
                  this.pieceJusti = fileReader.result;
                });

                fileReader.readAsDataURL(files[0]);
                this.pieceJusti = files[0];
              },

            showPieceJustifi(item) {
              this.optionPaiement = item
              this.dialogShowPiece = true
              this.showButtonPiece = false
              this.pieceJusti = item.urlPiece
            },
            submitApproCaisse (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        var form = document.getElementById('approForm')
                        var data = new FormData(form)
                        data.append('idUser', this.user.id)

                        let url = ''
                        if (this.approCourant.id) {
                            url = this.domaine + 'caisse/' + this.approCourant.id + '/edit/appro/caisse'
                        } else {
                            url = this.domaine + 'caisse/' + this.caisseCourant.id + '/new/appro/caisse'
                        }

                        this.$http.post(url, data).then(response => {
                                if (response.body) {
                                    let verif = response.body
                                    if (verif.code === 1) {
                                        if (this.approCourant.id) {
                                            this.$notify({
                                                title: 'MODIFICATION REUSSI',
                                                message: 'Approvisionnement de la caisse modifié avec succès.',
                                                type: 'success',
                                                position: 'top-center'
                                            })
                                        } else {
                                            this.$notify({
                                                title: 'ENREGISTREMENT REUSSI',
                                                message: 'Approvisionnement de la caisse enregistré avec succès.',
                                                type: 'success',
                                                position: 'top-center'
                                            })
                                        }
                                        this.dialogAjoutAppro = false
                                        this.loadAppro(this.caisseCourant)

                                        //AFFICHER LE MODAL DE CAISSE OU BANQUE
                                        if(this.caisseCourant.type === "Caisse"){
                                            this.showCaisse(this.caisseCourant)
                                        } else{
                                            this.showBanque(this.caisseCourant)
                                        }

                                        this.loading = false
                                    } else if (verif.code === 0) {
                                        this.$message.error(verif.message)
                                        this.loading = false
                                    }
                                } else {
                                    this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                    this.loading = false
                                }
                            },
                            response => {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                            })
                    }
                });
            },
            submitTransferCaisse () {
                if(this.soldeCaisse >= this.transFertForm.montantTransf) {
                    this.loading = true
                    var form = document.getElementById('transFertForm')
                    var data = new FormData(form)
                    data.append('montantTransf', this.transFertForm.montantTransf)
                    data.append('libelleTransfert', this.transFertForm.libelleTransfert)
                    data.append('idUser', this.user.id)
                    data.append('caisseCrediter', this.transFertForm.caisseSelect)
                    let url = this.domaine + 'caisse/' + this.caisseCourant.id + '/new/transfert/caisse'

                  this.$http.post(url, data).then(response => {
                      if (response.body) {
                          let verif = response.body
                          this.dialogAjoutTrans = false
                          if (verif.code === 1) {
                               this.$notify({
                                  title: 'ENREGISTREMENT REUSSI',
                                  message: 'Transfert dans une autre caisse enregistré avec succès.',
                                  type: 'success',
                                  position: 'top-center'
                              })
                              this.validTransfert = false
                              this.dialogAjoutAppro = false
                              this.loadAppro(this.caisseCourant)
                              //AFFICHER LE MODAL DE CAISSE OU BANQUE
                              if(this.caisseCourant.type === "Caisse"){
                                  this.showCaisse(this.caisseCourant)
                              } else{
                                  this.showBanque(this.caisseCourant)
                              }

                              this.loading = false
                          } else if (verif.code === 0) {
                              this.$message.error(verif.message)
                              this.loading = false
                          }
                      } else {
                          this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                          this.loading = false
                      }
                  },
                    response => {
                        this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                        this.loading = false
                    })
                }else{
                    this.$message.error("Montant à transférer est supérieur au solde de la caisse.")
                }
            },
            ClearApproForm() {
                this.dialogAjoutAppro = false
                this.$refs['approForm'].resetFields();
            },
            ClearTransfertForm() {
                this.dialogAjoutTrans = false
                this.$refs['transFertForm'].resetFields();
            },
            submitValideAppro () {
                this.loading = true
                if (this.$refs.formValideAppro.validate() && this.selectReponseAppro != "") {
                    var form = document.getElementById('formValideAppro')
                    var data = new FormData(form)
                    data.append('idUser', this.user.id)
                    data.append('reponse', this.selectReponseAppro)
                    let url = this.domaine + 'caisse/' + this.approCourant.id + '/valide/appro'
                    this.$http.post(url, data).then(response => {
                            if (response.body) {
                                let verif = response.body
                                if (verif.code === 1) {
                                    this.$notify({
                                        title: 'ENREGISTREMENT REUSSI',
                                        message: 'Validation enregistré avec succès.',
                                        type: 'success',
                                        position: 'top-center'
                                    })
                                    this.dialogAjoutValideAppro = false
                                    this.loadAppro(this.caisseCourant)
                                    this.showCaisse(this.caisseCourant)
                                    this.loading = false
                                } else if (verif.code === 0) {
                                    this.$message.error(verif.message)
                                    this.loading = false
                                }
                            } else {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                            }
                        },
                        response => {
                            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                            this.loading = false
                        })
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La validation n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
            imprimerFacture (ligne) {
                let url = ""
                let mode = 2
                if(ligne.type == 1){
                    url = this.domaine + 'fournisseur/' + ligne.idFact + '/'+ this.user.id +'/imprimer/facture/'+mode
                }
                else {
                    url = this.domaine + 'fournisseur/' + ligne.idFact + '/'+ this.user.id +'/imprimer/factureParc'
                }

                this.$http.get(url).then(response => {
                    if (response.body) {
                    }
                })
                window.open(url)
            },
            imprimeListeHis (type) {
                let idCaisse = this.caisseCourant.id
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"caisse/imprimerPDF/historique/"+idCaisse+"/"+this.dateDbt+"/"+this.dateFin
                }else {
                    url = this.domaine+"caisse/imprimerEXC/historique/"+idCaisse+"/"+this.dateDbt+"/"+this.dateFin
                }
                window.open(url)
            },
            imprimerReglement (ligne) {
                this.reglementCourant = ligne
                let url = this.domaine + 'caisse/' + this.reglementCourant.id + '/imprimer/reglement/'+this.user.id
                this.$http.get(url).then(response => {
                    if (response.body) {
                    }
                })
                window.open(url)
            },
            imprimerAppro (ligne) {
                this.approCourant = ligne
                let url = this.domaine + 'caisse/' + this.approCourant.id + '/imprimer/appro/'+this.user.id+'/caisse'
                this.$http.get(url).then(response => {
                    if (response.body) {
                    }
                })
                window.open(url)
            },
            imprimeSearchFacture(item) {

                this.selectFournisseur =  this.selectFournisseur != '' ? this.selectFournisseur : "null";
                this.selectTypeFacture =  this.selectTypeFacture != '' ? this.selectTypeFacture : "null";
                this.selectEtatFacture =  this.selectEtatFacture != '' ? this.selectEtatFacture : "null";
                this.dateFacture =  this.dateFacture != '' ? this.dateFacture : "null";

                let url = this.domaine + 'caisse/impression/facture/search/'+item+'/'+this.user.id+'/'+this.selectFournisseur+'/'+this.selectTypeFacture+'/'+this.selectEtatFacture+'/'+this.dateFacture
                window.open(url)

                this.selectFournisseur = ''
                this.selectTypeFacture = ''
                this.selectEtatFacture = ''
                this.dateFacture = ''
            },
            imprimeHistoCaisse(item) {
                let url = this.domaine + 'caisse/impression/historique/appro/'+item
                window.open(url)
            },
            imprimeAllTresorerie(item) {
                let url = this.domaine + 'caisse/impression/liste/tresor'
                window.open(url)
            },

            imprimeRech() {
              var formdata = new FormData();

            let  url = this.domaine + "caisse/imprimerPDF/listeRecherche";
            formdata.append('idUser', this.user.id)
            formdata.append('periode', this.formTri.periode)
            formdata.append('tresorerie', this.selectTresor)
            formdata.append('type', this.selectTypes)

            let req=new XMLHttpRequest();
            this.$http
              .post(url, formdata, { responseType: "arraybuffer" })
              .then(response => {
                let blob = new Blob([response.data], {
                  type: response.headers.get("content-type")
                });

                let url = URL.createObjectURL(blob);
                this.loading = false;
                window.open(url);
              });

            },
            statAllbilan () {
                //somme des entrée et des sorties
                let optionAllBilan = {
                    title: {
                        text: 'TOTAL DES MONTANTS CREDIT ET DEBIT DES TRESORERIES',
                        subtext: '',
                        left: 'center'
                    },
                    color: ['#67C23A', '#e5323e'],
                    tooltip : {
                        trigger: 'axis',
                        axisPointer : {
                            type : 'shadow'
                        }
                    },
                    legend: {
                        data:[]
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [{
                        type : 'category',
                        data:[]
                    }],
                    yAxis : [{ type : 'value' }],
                    series : [
                        {
                            name:'Montant entrée ',
                            type:'bar',
                            barWidth : 30,
                            data:[]
                        },
                        {
                            name:'Montant sortie ',
                            type:'bar',
                            barWidth : 30,
                            data:[]
                        }
                    ]
                }

                this.statAllCaisse.forEach(function(element) {
                    optionAllBilan.xAxis[0].data.push(element.date);
                    optionAllBilan.series[0].data.push(element.entree)
                    optionAllBilan.series[1].data.push(element.sortie)
                })

                let chartAllBilan = echarts.init(document.getElementById('chartAllBilan'))
                chartAllBilan.setOption(optionAllBilan)
            },
            statAllbilanCaisse () {
                //somme des entrée et des sorties
                let optionAllBilanCaisse = {
                    title: {
                        text: 'TOTAL DES MONTANTS CREDIT ET DEBIT DE LA CAISSE',
                        subtext: '',
                        left: 'center'
                    },
                    color: ['#67C23A', '#e5323e'],
                    tooltip : {
                        trigger: 'axis',
                        axisPointer : {
                            type : 'shadow'
                        }
                    },
                    legend: {
                        data:[]
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [{
                        type : 'category',
                        data : []
                    }],
                    yAxis : [{ type : 'value' }],
                    series : [
                        {
                            name:'Montant entrée ',
                            type:'bar',
                            barWidth : 30,
                            data:[]
                        },
                        {
                            name:'Montant sortie ',
                            type:'bar',
                            barWidth : 30,
                            data:[]
                        }
                    ]
                }

                this.statCaisse1.forEach(function(element) {
                    optionAllBilanCaisse.xAxis[0].data.push(element.date);
                    optionAllBilanCaisse.series[0].data.push(element.entree)
                    optionAllBilanCaisse.series[1].data.push(element.sortie)
                })

                let chartAllBilanCaisseOnly = echarts.init(document.getElementById('chartAllBilanCaisseOnly'))
                chartAllBilanCaisseOnly.setOption(optionAllBilanCaisse)
            },
            deleteCaisse () {
                let url = this.domaine + 'caisse/' + this.idCaisse + '/delete'
                this.$http.get(url).then(response => {
                    if (response.body.code == 1) {
                        this.$notify({
                            title: 'SUPPRESSION',
                            message: 'Caisse supprimé avec succès.',
                            type: 'success',
                            position: 'top-center'
                        })
                        this.dialogSupr = false
                        this.loadCaisse()
                        this.loadPage()
                    } else if (response.body.code == 0){

                        this.$notify({
                            title: 'SUPPRESSION',
                            message: 'Impossible de supprimer la caisse.',
                            type: 'error',
                            position: 'top-center'
                        })
                        this.dialogSupr = false
                    }

                })
            },
            deleteAppro () {
                let url = this.domaine + 'caisse/' + this.idAppro + '/delete/approvisionnement'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        let verif = response.body
                        if (verif.code === 1) {
                            this.$notify({
                                title: 'SUPPRESSION',
                                message: 'Approvisionnement supprimé avec succès.',
                                type: 'success',
                                position: 'top-center'
                            })
                        } else if (verif.code === 2) {
                            this.$notify({
                                title: 'SUPPRESSION',
                                message: verif.message,
                                type: 'warning',
                                position: 'top-center'
                            })
                        }
                        this.dialogSuprAppro = false
                        this.loadCaisse()
                        this.showCaisse(this.caisseCourant)
                        this.loadAppro(this.caisseCourant)
                        this.loadPage()
                    }
                })
            },
            closeLoadReglement () {
                this.dialogLoadReglement = false
                this.dialogAjoutReglement = false
                this.dialogEditReglement = false
                this.dialogEdit = false
            },
            clear () {
                this.$refs.form.reset()
                this.dialogAjout = false
            },
            // DEMANDEUR
            loadDemandeur() {
                let url = this.domaine +  'maintenance/listes-demandeur'
                var formdata = new FormData();
                formdata.append('user', this.user.id)

                this.$http.get(url, formdata).then(response => {
                        this.listeDemandeur = response.body;
                    },
                    response => {
                        this.$message.error("Une erreur est survenue lors du chargement de la liste des demandeurs'")
                    })
            },

            showBanque (ligne) {

                this.dialogModalBanque = true
                // this.dialogShow = true
                this.caisseCourant = ligne

                this.listFacture = []
                let url = this.domaine + 'caisse/' + this.caisseCourant.id + '/show'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.detailCaisse = response.body.caisse
                        this.detailCaisseS = response.body.details
                        this.montantSortie = response.body.montantSortie
                        this.montantEntree = response.body.montantEntree
                        this.montantTvaEntree = response.body.montantTvaEntree
                        this.montantTvaSortie = response.body.montantTvaSortie
                        this.totalEntree = response.body.totalEntree
                        this.totalSortie = response.body.totalSortie
                        this.statCaisse2 = response.body.stats1
                        this.statAllbilanBanque()

                    }
                })
            },
            statAllbilanBanque () {
        //somme des entrée et des sorties
        let optionAllBilanBanque = {
          title: {
            text: 'TOTAL DES MONTANTS CREDIT ET DEBIT DE LA BANQUE',
            subtext: '',
            left: 'center'
          },
          color: ['#67C23A', '#e5323e'],
          tooltip : {
            trigger: 'axis',
            axisPointer : {
              type : 'shadow'
            }
          },
          legend: {
            data:[]
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis : [{
            type : 'category',
            data : []
          }],
          yAxis : [{ type : 'value' }],
          series : [
            {
              name:'Montant entrée ',
              type:'bar',
              barWidth : 30,
              data:[]
            },
            {
              name:'Montant sortie ',
              type:'bar',
              barWidth : 30,
              data:[]
            }
          ]
        }
        this.statCaisse2.forEach(function(element) {
          optionAllBilanBanque.xAxis[0].data.push(element.date);
          optionAllBilanBanque.series[0].data.push(element.entree)
          optionAllBilanBanque.series[1].data.push(element.sortie)
        })

        let chartAllBilanBanque = echarts.init(document.getElementById('chartAllBilanBanque'))
        chartAllBilanBanque.setOption(optionAllBilanBanque)
        },

            loadListApproDgCheqBanque (item) {
                this.loading = true
                let url = this.domaine + 'caisse/appro/'+ item +'/valide-dg-cheque/a-confirmer'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listApproDgCheq = response.body.listApproCheq
                        this.loading = false
                    }
                })
            },
        },
        mounted () {
            this.loadPage()
            this.loadUser()
            this.loadClient()
            this.loadFournisseur()
            this.loadCaisse()
            // this.showBanque()
            this.statAllbilan()
            this.loadDemandeur()
        },
        beforeMount: function () {
            if(!this.roleAcces[this.$router.history.current.name]){
                this.$router.push({ name: 'Home'  })
            }
        }
    };
</script>
<style>
    .el-tabs--border-card
    {
        background: #FAFAFA;
    }

    .tooltip-btn {
    position: relative;
    background-color: grey;
    color: white;
  }

  .tooltip-btn::after {
    content: attr(title);
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px;
    border-radius: 5px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    color: white;
    transition: opacity 0.9s, visibility 0.9s;
  }

  .tooltip-btn:hover::after {
    opacity: 1;
    visibility: visible;
  }
</style>



// WEBPACK FOOTER //
// src/components/Caisse.vue